import React, { useEffect, useState, } from 'react';
import { Link, useHistory, useParams, } from 'react-router-dom';
import HtmlParser from 'react-html-parser';

import { v4 as uuidv4 } from 'uuid';
import Swal from 'sweetalert2';
import $ from 'jquery';

import 'react-tempusdominus-bootstrap';

import axios from 'axios';

import useAuth from '../../controllers/users/useAuth';
import {
    checkIfUserIsMaster, dataTableLanguaje, buttonProcessGet, responseGet, globalSettings, sendMessage, styles, validateEmail, sendMessageCloseCurrentWindowAsync, awaitDelay,
    processEvaluateGet, numberSet, dateTimeFormatGlobalSet, languageObjGet, isUndNullEmp, LoadingSection,
} from '../../helpers/settings';

import { elevatorModelGet, } from '../../models/elevators/elevator';
import { inventoryModelGet } from '../../models/inventories/inventory';
import Menu from '../main/Menu';
import ElevatorAddEditDetails from '../elevators/ElevatorAddEditDetails';
import InventoryAddEditDetails from '../inventories/InventoryAddEditDetails';
import CommonAreaAddEditDetails from '../commonAreas/CommonAreaAddEditDetails';
import { commonAreaModelGet } from '../../models/commonArea/commonArea';
import { userByIdGetAsync, } from '../../controllers/users/users';
import { validationCoinGetAsync } from '../../helpers/validations';
import BuildingContracts from './BuildingContracts';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { buildingModelGet } from '../../models/buildings/building';

const currentMethod = 'BuildingEdit';

export default function BuildingEdit({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    const { id, } = useParams();
    let buildingTwo = buildingModelGet({});
    let result;
    let dataObj = {};
    let headerObj = {};
    let swalProperties = {};
    const auth = useAuth();
    const history = useHistory();
    const userRole = checkIfUserIsMaster({ email: auth?.user?.email || '', languageId: languageObj?.id, subMethod: currentMethod, })?.result;
    const [processValues, setProcessValues] = useState({
        $,
        auth: auth,
        dtId: '',
        rowIndex: 0,
        showModal: false,
        setShowModal: null,
        type: 0,
        user: {},
    });
    //const [showLoading, //setShowLoading] = useState(true);
    //const [showData, setShowData] = useState(false);
    const [isEditDelete, setIsEditDelete] = useState(false);
    const [showLoading, setShowLoading] = useState({ building: true, floorsParkingStalls: true, elevators: true, inventory: true, commonArea: true, settings: true, });
    const processName = {
        accountsReceivableAliquotPercentage: 'accountsReceivableAliquotPercentage',
        usersMaxLockoutAttemps: 'usersMaxLockoutAttemps',
    };
    const tabs = {
        ids: {
            accountsReceivable: 'accountsReceivableTabId',
            accountsPayable: 'accountsPayableTabId',
            collectionCashes: 'collectionCashesTabId',
            bankAccounts: 'bankAccountsTabId',
            users: 'usersTabId',
        },
        className: 'tab-pane fade',
        panes: {
            ids: {
                accountsReceivable: 'accountsReceivablePaneId',
                accountsPayable: 'accountsPayablePaneId',
                collectionCashes: 'collectionCashesPaneId',
                bankAccounts: 'bankAccountsPaneId',
                users: 'usersPaneId',
            },
            role: 'tabpanel',
        },
    };
    //#endregion variables

    //#region building
    const aliquotPercentageId = 'aliquotPercentage';
    //const buildingContractDateId = 'buildingContractDate';
    //const [floorsIsDisabled, setFloorsIsDisabled] = useState(userRole !== globalSettings?.roles?.master && userRole !== globalSettings?.roles?.admin);
    const [floorsIsDisabled] = useState(userRole !== globalSettings?.roles?.master && userRole !== globalSettings?.roles?.admin);
    const maxLockoutAttemps = [
        { id: 0, description: globalSettings?.labels?.lockDisabled?.[languageObj?.id] }, { id: 1, description: `${globalSettings?.labels?.attemptsAllowed?.[languageObj?.id]}: 1` },
        { id: 2, description: `${globalSettings?.labels?.attemptsAllowed?.[languageObj?.id]}: 2` }, { id: 3, description: `${globalSettings?.labels?.attemptsAllowed?.[languageObj?.id]}: 3` },
        { id: 4, description: `${globalSettings?.labels?.attemptsAllowed?.[languageObj?.id]}: 4` }, { id: 5, description: `${globalSettings?.labels?.attemptsAllowed?.[languageObj?.id]}: 5` },
        { id: 6, description: `${globalSettings?.labels?.attemptsAllowed?.[languageObj?.id]}: 6` }, { id: 7, description: `${globalSettings?.labels?.attemptsAllowed?.[languageObj?.id]}: 7` },
        { id: 8, description: `${globalSettings?.labels?.attemptsAllowed?.[languageObj?.id]}: 8` }, { id: 9, description: `${globalSettings?.labels?.attemptsAllowed?.[languageObj?.id]}: 9` },
        { id: 10, description: `${globalSettings?.labels?.attemptsAllowed?.[languageObj?.id]}: 10` },
    ];
    //#endregion building

    //#region contracts
    const contractsDtId = 'contractsDt';
    const [contracts, setContracts] = useState([]);
    const [contractsDt, setContractsDt] = useState([]);
    const [contractShowModal, setContractShowModal] = useState(false);
    //#endregion contracts

    //#region elevators
    let elevators = [];
    const [elevator, setElevator] = useState({});
    const dtElevatorsId = 'dtElevators';
    const [showModalElevator, setShowModalElevator] = useState(false);
    //#endregion elevators

    //#region Inventories
    let inventories = [];
    const [inventory, setInventory] = useState({});
    const dtInventoriesId = 'dtInventory';
    const [showModalInventory, setShowModalInventory] = useState(false);
    //#endregion Inventories

    //#region variables
    const [building, setBuilding] = useState(buildingModelGet({}));
    const [coins, setCoins] = useState([]);
    const [descriptionError, setDescriptionError] = useState('');
    const [yearError, setYearError] = useState('');
    const [addressError, setAddressError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [contractError, setContractError] = useState('');
    const [coinBaseError, setCoinBaseError] = useState('');
    const [coinOtherError, setCoinOtherError] = useState('');
    const [apartmentsPerTopLevelError, setApartmentsPerTopLevelError] = useState('');
    const [apartmentsPerFloorsError, setApartmentsPerFloorsError] = useState('');
    const [apartmentsPerLowLevelError, setApartmentsPerLowLevelError] = useState('');
    const [totalApartments, setTotalApartments] = useState(0);
    //#endregion variables

    //#region reserve common area
    let commonAreas = [];
    const dtCommonAreasId = 'dtCommonAreas';
    const [commonAreaShowModal, setCommonAreaShowModal] = useState(false);
    const [commonArea, setCommonArea] = useState({});
    //#endregion reserve common area

    //#region variables (others)
    const controls = {
        buttons: {
            save: {
                className: 'btn btn-outline-warning',
                id: 'btnSave',
            },
            contract: {
                className: 'btn btn-outline-info mx-1',
                id: 'btnContract',
            },
            back: {
                className: 'btn btn-outline-success',
                id: 'btnBack',
            },
        },
        checkBox: {
            topLevel: {
                id: 'chkTopLevel',
                className: 'icheck-primary',
            },
            lowLevel: {
                id: 'chkLowLevel',
                className: 'icheck-primary',
            }
        },
        dataTables: {
            elevators: {
                buttons: {
                    add: {
                        id: 'btnElevatorsAdd',
                        className: 'btn btn-outline-success float-right btn-sm',
                    },
                },
                icons: {
                    add: {
                        id: 'icoElevatorsAdd',
                        className: globalSettings?.icons?.plusCircle,
                    },
                },
                inputs: {
                    search: {
                        id: `${dtElevatorsId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtElevatorsId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    add: {
                        id: 'spElevatorsAdd',
                        className: '',
                    },
                },
            },
            inventories: {
                buttons: {
                    add: {
                        id: 'btnInventoiresAdd',
                        className: 'btn btn-outline-success float-right btn-sm',
                    },
                },
                icons: {
                    add: {
                        id: 'icoInventoiresAdd',
                        className: globalSettings?.icons?.plusCircle,
                    },
                },
                inputs: {
                    search: {
                        id: `${dtInventoriesId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtInventoriesId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    add: {
                        id: 'spInventoiresAdd',
                        className: '',
                    },
                },
            },
            commonAreas: {
                buttons: {
                    add: {
                        id: 'btnCommonAreasAdd',
                        className: 'btn btn-outline-success float-right btn-sm',
                    },
                },
                icons: {
                    add: {
                        id: 'icoCommonAreasAdd',
                        className: globalSettings?.icons?.plusCircle,
                    },
                },
                inputs: {
                    search: {
                        id: `${dtCommonAreasId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtCommonAreasId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    add: {
                        id: 'spCommonAreasAdd',
                        className: '',
                    },
                },
            },
        },
        icons: {
            save: {
                id: 'iconSave',
                className: globalSettings?.icons?.save,
            },
            contract: {
                id: 'iconContract',
                className: globalSettings?.icons?.fileInvoice,
            },
            back: {
                id: 'iconBack',
                className: globalSettings?.icons?.arrowCircleLeft,
            },
        },
        inputs: {
            description: {
                id: 'inputDescription',
                className: 'form-control',
            },
            year: {
                id: 'inputYear',
                className: 'form-control',
            },
            email: {
                id: 'inputEmail',
                className: 'form-control',
            },
            address: {
                id: 'inputAddress',
                className: 'form-control',
            },
            contract: {
                id: 'inputContract',
                className: 'form-control bg-transparent text-black',
            },
            apartmentsPerTopLevel: {
                id: 'inputApartmentsPerTopLevel',
                className: 'form-control',
            },
            floors: {
                id: 'inputFloors',
                className: 'form-control',
            },
            apartmentsPerFloor: {
                id: 'inputApartmentsPerFloor',
                className: 'form-control',
            },
            apartmentsPerLowLevel: {
                id: 'inputApartmentsPerLowLevel',
                className: 'form-control',
            },
            parkingStalls: {
                id: 'inputParkingStalls',
                className: 'form-control',
            },
        },
        selects: {
            coinBase: {
                id: 'selCoinBase',
                className: 'form-select',
            },
            coinOther: {
                id: 'selCoinOther',
                className: 'form-select',
            },
        },
        spinners: {
            save: {
                id: 'spSave',
                className: '',
            },
            contract: {
                id: 'spContract',
                className: '',
            },
            back: {
                id: 'spBack',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion variables (others)

    //#region building (methods)
    //#region old code
    // const dateInControlSetAsync = (date, buildingContractDate) => {
    //     let response = responseGet();
    //     try {
    //         let localDate = '';
    //         const localDateFormat = globalSettings?.react?.tempusDominus?.format?.date?.dmy;
    //         const localDateFormatTwo = globalSettings?.react?.tempusDominus?.format?.date?.DDMMYYYY;
    //         const localTimeFormatTwo = globalSettings?.react?.tempusDominus?.formatTimehhmmA;

    //         if (!isUndefined(buildingContractDate) && !isNull(buildingContractDate)) {
    //             localDate = dateTimeFormatGlobalSet(buildingContractDate, localDateFormat, 12, false).result;
    //         } else if (!isUndefined(date) && !isNull(date)) {
    //             localDate = dateTimeFormatGlobalSet(date, localDateFormat, 12, false).result;
    //         }

    //         $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
    //             icons: globalSettings?.react?.tempusDominus?.icons,
    //             buttons: globalSettings?.react?.tempusDominus?.buttons,
    //             tooltips: globalSettings?.react?.tempusDominus?.tooltips,
    //             locale: 'es',
    //         });

    //         $(`#${buildingContractDateId}`)?.datetimepicker({
    //             date: moment(`${localDate}`, `${localDateFormatTwo} ${localTimeFormatTwo}`),
    //             default: false,
    //             format: `${localDateFormatTwo} ${localTimeFormatTwo}`,
    //         });
    //     } catch (ex) {
    //         response.isSuccess = false;
    //         response.msgType = -1;
    //         response.msgText = `Method: dateInControlSetAsync<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //     }
    //     return response;
    // }
    //#endregion old code

    const formDataSet = ({ property = '', value = '', subMethod = '', }) => {
        const currentMethod = 'formDataSet';
        let response = responseGet();
        try {
            //#region data set
            setBuilding({ ...building, [property]: value, });
            //#endregion data set

            //#region calculate total apartments
            const properties = [
                'apartmentsPerTopLevel',
                'floors',
                'apartmentsPerFloor',
                'apartmentsPerLowLevel',
            ];
            const calculateTA = properties?.some((a) => a?.includes(property));
            if (calculateTA) {
                response = calculateTotalApartments({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    //return response;
                    sendMessage({
                        msgType: response?.msgType,
                        msgText: response?.msgText,
                        timer: 0,
                        confirmButton: true,
                        showProgressBar: false,
                        swal: null,
                        update: '',
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
            }
            //#endregion calculate total apartments
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            response.result = `${currentMethod} - error`;
            sendMessage({
                msgType: response?.msgType,
                msgText: response?.msgText,
                timer: 0,
                confirmButton: true,
                showProgressBar: false,
                swal: null,
                update: '',
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    const contractAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'contractAsync';
        let response = responseGet();
        try {
            //#region variables
            let contractsLocal = [];
            let contractsDtLocal = [];
            //#endregion variables

            //#region initialize
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }
            //#endregion initialize

            controlsStatusSet({ processType: 2, subMethod: currentMethod, });

            //#region data get (buildingContracts)
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                conditionals: [
                    { field: globalSettings?.collections?.properties?.buildingId, operator: globalSettings?.react?.firebase?.operators?.equalTo, value: `${building.id}`, },
                ],
                ordersBy: [
                    { field: globalSettings?.collections?.properties?.dateStart, value: 'desc', },
                ],
                buildingId: building.id,
                languageId: languageObj?.id,
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlBuildingContracts}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            contractsLocal = response?.result;
            setContracts(contractsLocal);
            //#endregion data get (buildingContracts)

            //#region set contractsDt
            if (!isUndNullEmp({ data: contractsLocal, subMethod: currentMethod, })?.result && contractsLocal?.length > 0) {
                contractsLocal?.forEach((detail) => {
                    contractsDtLocal?.push([
                        dateTimeFormatGlobalSet({
                            date: detail?.dateStart,
                            type: globalSettings?.react?.tempusDominus?.format?.date?.ymdTwo,
                            format: 24,
                            addTime: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        }).result,
                        detail?.subContractId,
                        dateTimeFormatGlobalSet({
                            date: detail?.dateStart,
                            type: languageObj?.format?.date?.f1,
                            format: 0,
                            addTime: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result,
                        dateTimeFormatGlobalSet({
                            date: detail?.dateEnd,
                            type: languageObj?.format?.date?.f1,
                            format: 0,
                            addTime: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result,
                        buttonProcessGet({
                            id: detail?.id,
                            description: detail?.subContractId,
                            showDetails: true,
                            labelDetails: globalSettings?.labels?.detail?.[languageObj?.id],
                            enabledDetails: true,
                            showEdit: true,
                            labelEdit: globalSettings?.labels?.edit?.[languageObj?.id],
                            enabledEdit: processEvaluateGet({
                                object: detail,
                                property: globalSettings?.labels?.process?.en?.toLowerCase(),
                                process: globalSettings?.labels?.edit?.en?.toLowerCase(),
                                subMethod: currentMethod,
                            })?.result,
                            showDelete: true,
                            labelDelete: globalSettings?.labels?.delete?.[languageObj?.id],
                            enabledDelete: processEvaluateGet({
                                object: detail,
                                property: globalSettings?.labels?.process?.en?.toLowerCase(),
                                process: globalSettings?.labels?.delete?.en?.toLowerCase(),
                                subMethod: currentMethod,
                            })?.result,
                            processButtons: [],
                            subMethod: currentMethod,
                        })?.result,
                    ])
                });
            }

            setContractsDt(contractsDtLocal);
            //#endregion set contractsDt

            setContractShowModal(true);
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
        return response;
    }

    const goBackAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'goBackAsync';
        let response = responseGet();
        try {
            e.preventDefault();
            controlsStatusSet({ processType: 3, subMethod: currentMethod, });
            await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
            history.push(globalSettings?.app?.backend?.urlBuildings);
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    const errosDefaultSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'errosDefaultSetAsync';
        let response = responseGet();
        try {
            setDescriptionError('');
            setYearError('');
            setAddressError('');
            setEmailError('');
            setContractError('');
            setCoinBaseError('');
            setApartmentsPerTopLevelError('');
            setApartmentsPerFloorsError('');
            setApartmentsPerLowLevelError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            response.result = `${currentMethod} - error`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const formDataValidateAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'formDataValidateAsync';
        let response = responseGet();
        try {
            if (isUndNullEmp({ data: building?.description, subMethod: currentMethod, })?.result) {
                setDescriptionError(globalSettings?.messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (parseInt(building?.year) <= 0) {
                setYearError(globalSettings?.messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            } else if (building?.year?.toString()?.length !== 4) {
                setYearError(`${globalSettings?.messages?.thisFieldRequired?.[languageObj?.id]}. 4 ${globalSettings?.labels?.characters?.[languageObj?.id]}`);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: building?.address, subMethod: currentMethod, })?.result) {
                setAddressError(`${globalSettings?.messages?.thisFieldRequired?.[languageObj?.id]}`);
                response.isWarning = true;
            }

            if (!isUndNullEmp({ data: building?.email, subMethod: currentMethod, })?.result && !validateEmail({ email: building?.email, })) {
                setEmailError(`${globalSettings?.messages?.youMustEnterValidEmail?.[languageObj?.id]}`);
                response.isWarning = true;
            }

            //#region old code
            // if (isUndefined(building.coinBaseId) || isNull(building.coinBaseId) || isEmpty(building.coinBaseId)) {
            //     setCoinBaseError(`${globalSettings?.messages?.thisFieldRequired?.[languageObj?.id]}`);
            //     response.isWarning = true;
            // }
            //#endregion old code

            if (building?.topLevel) {
                if (building?.apartmentsPerTopLevel <= 0) {
                    setApartmentsPerTopLevelError(`${globalSettings?.messages?.thisFieldRequired?.[languageObj?.id]}. ${globalSettings?.messages?.mustBeGreaterThan?.[languageObj?.id]} <b>0</b>`);
                    response.isWarning = true;
                }
            }

            if (building?.floors > 0 && building?.apartmentsPerFloor <= 0) {
                setApartmentsPerFloorsError(`${globalSettings?.messages?.thisFieldRequired?.[languageObj?.id]}. ${globalSettings?.messages?.mustBeGreaterThan?.[languageObj?.id]} <b>0</b>`);
                response.isWarning = true;
            }

            if (building?.lowLevel) {
                if (building.apartmentsPerLowLevel <= 0) {
                    setApartmentsPerLowLevelError(`${globalSettings?.messages?.thisFieldRequired?.[languageObj?.id]}. ${globalSettings?.messages?.mustBeGreaterThan?.[languageObj?.id]} <b>0</b>`);
                    response.isWarning = true;
                }
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const buildingEditPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'buildingEditPostAsync';
        let response = responseGet();
        try {
            //#region initialize
            e?.preventDefault();

            response = await formValuesCheckAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await errosDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion initialize

            //#region data save
            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlBuildings}/${building.id}`,
                building: building,
                languageId: languageObj?.id,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            setBuilding(response?.result?.building);
            buildingTwo = response?.result?.building;
            //#endregion data save

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    const formValuesCheckAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'formValuesCheckAsync';
        let response = responseGet();
        try {
            building.floors = parseInt($(`#${controls?.inputs?.floors?.id}`).val()) > 0 ? parseInt($(`#${controls?.inputs?.floors?.id}`).val()) : 0;
            building.apartmentsPerFloor = parseInt($(`#${controls?.inputs?.floors?.id}`).val()) > 0 ? parseInt($(`#${controls?.inputs?.apartmentsPerFloor?.id}`).val()) > 0 ? parseInt($(`#${controls?.inputs?.apartmentsPerFloor?.id}`).val()) : 0 : 0;
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            response.result = `${currentMethod} - error`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const apartmentsTopLevelSet = ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'apartmentsTopLevelSet';
        let response = responseGet();
        try {
            setApartmentsPerTopLevelError('');
            building.topLevel = e?.target?.checked || false;
            formDataSet({ property: 'apartmentsPerTopLevel', value: 0, subMethod: currentMethod, });

            //#region calculate total apartments
            response = calculateTotalApartments({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                sendMessage({
                    msgType: response?.msgType,
                    msgText: response?.msgText,
                    timer: 0,
                    confirmButton: true,
                    showProgressBar: false,
                    swal: null,
                    update: '',
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion calculate total apartments
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            response.result = `${currentMethod} - error`;
            sendMessage({
                msgType: response?.msgType,
                msgText: response?.msgText,
                timer: 0,
                confirmButton: true,
                showProgressBar: false,
                swal: null,
                update: '',
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    const apartmentsLowLevelSet = ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'apartmentsLowLevelSet';
        let response = responseGet();
        try {
            setApartmentsPerLowLevelError('');
            building.lowLevel = e?.target?.checked;
            formDataSet({ property: 'apartmentsPerLowLevel', value: 0, subMethod: currentMethod, });

            //#region calculate total apartments
            response = calculateTotalApartments({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                //return response;
                sendMessage({
                    msgType: response?.msgType,
                    msgText: response?.msgText,
                    timer: 0,
                    confirmButton: true,
                    showProgressBar: false,
                    swal: null,
                    update: '',
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion calculate total apartments
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            response.result = `${currentMethod} - error`;
            sendMessage({
                msgType: response?.msgType,
                msgText: response?.msgText,
                timer: 0,
                confirmButton: true,
                showProgressBar: false,
                swal: null,
                update: '',
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    const calculateTotalApartments = ({ subMethod = '', }) => {
        const currentMethod = 'calculateTotalApartments';
        let response = responseGet();
        try {
            //#region variables
            const apartmentsPerTopLevel = parseInt($(`#${controls?.inputs?.apartmentsPerTopLevel?.id}`).val()) > 0 && $(`#${controls?.checkBox?.topLevel?.id}`).prop('checked') ? parseInt($(`#${controls?.inputs?.apartmentsPerTopLevel?.id}`).val()) : 0;
            const floors = parseInt($(`#${controls?.inputs?.floors?.id}`).val()) > 0 ? parseInt($(`#${controls?.inputs?.floors?.id}`).val()) : 0;
            const apartmentsPerFloor = parseInt($(`#${controls?.inputs?.apartmentsPerFloor?.id}`).val()) > 0 ? parseInt($(`#${controls?.inputs?.apartmentsPerFloor?.id}`).val()) : 0;
            const apartmentsPerLowLevel = parseInt($(`#${controls?.inputs?.apartmentsPerLowLevel?.id}`).val()) > 0 && $(`#${controls?.checkBox?.lowLevel?.id}`).prop('checked') ? parseInt($(`#${controls?.inputs?.apartmentsPerLowLevel?.id}`).val()) : 0;
            //#endregion variables

            //#region process
            setTotalApartments(apartmentsPerTopLevel + (floors * apartmentsPerFloor) + apartmentsPerLowLevel);
            //#endregion process
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            response.result = `${currentMethod} - error`;
        }
        return response;
    }
    //#endregion building (methods)

    //#region elevators (methods)
    const dataTableElevatorsSet = ({ subMethod = '', }) => {
        const currentMethod = 'dataTableElevatorsSet';
        let response = responseGet();
        try {
            //dtElevators = $(`#${dtElevatorsId}`)?.DataTable({
            $(`#${dtElevatorsId}`)?.DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: globalSettings?.labels?.description?.[languageObj?.id], width: '55%', },
                    { title: globalSettings?.labels?.type?.[languageObj?.id], width: '10%', },
                    { title: globalSettings?.labels?.brand?.[languageObj?.id], width: '15%', },
                    { title: globalSettings?.labels?.model?.[languageObj?.id], width: '15%', },
                    { title: globalSettings?.labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
            //.buttons().container().appendTo(`#${dtElevatorsId}_wrapper .col-md-6:eq(0)`);
            //queryCodeSet();
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            response.result = `${currentMethod} - error`;
        }
        return response;
    }

    const elevatorAddGetAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'elevatorAddGetAsync';
        let response = responseGet();
        try {
            controlsStatusSet({ processType: 4, subMethod: currentMethod, });

            //#region Initial set values
            setElevator(elevatorModelGet({
                id: uuidv4(),
                userId: auth?.user?.uid,
                isEven: true,
            }));

            //#region set process values
            setProcessValues({
                auth: auth,
                dtId: dtElevatorsId,
                rowIndex: 0,
                showModal: false,
                setShowModal: null,
                type: 0,
                user: {},
            });
            //#endregion set process values

            //#endregion Initial set values
            await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
            setShowModalElevator(true);
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    const elevatorGetType = ({ data = {}, subMethod = '', }) => {
        const currentMethod = 'elevatorGetType';
        let response = responseGet();
        try {
            if (data?.both) {
                response.result = globalSettings?.labels?.both?.[languageObj?.id];
            } else if (data?.even) {
                response.result = globalSettings?.labels?.even?.[languageObj?.id];
            } else if (data?.odd) {
                response.result = globalSettings?.labels?.odd?.[languageObj?.id];
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            response.result = `${currentMethod} - error`;
            console?.error(response);
        }
        return response;
    }

    const elevatorEditDetailsGetAsync = async ({ id_ = '', description = '', rowIndex = 0, processType = 0, subMethod = '', }) => {
        const currentMethod = 'elevatorEditDetailsGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let user = {};
            let elevatorLocal = elevatorModelGet({});
            //#region response is warning
            let responseIsWarning = responseGet();
            responseIsWarning.isWarning = true;
            responseIsWarning.msgType = 1;
            //responseIsWarning.msgText = `Method: elevatorEditDetailsGetAsync<br/>`;
            //#endregion response is warning
            //#endregion variables

            setShowLoading({ building: false, floorsParkingStalls: false, elevators: true, inventory: false, commonArea: false, settings: false, });

            //#region set initial values
            if (isUndNullEmp({ data: buildingTwo?.elevators, subMethod: currentMethod, })?.result) {
                setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: globalSettings?.messages?.youMustCreateLeastOneElevator?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: '',
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            elevatorLocal = buildingTwo?.elevators?.find(({ id }) => id === id_);

            if (isUndNullEmp({ data: elevatorLocal, subMethod: currentMethod, })?.result) {
                setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
                responseIsWarning.msgText = `${globalSettings?.messages?.theRecordCannotBeLocated?.[languageObj?.id]}:<br/>`;
                responseIsWarning.msgText += `<b>${description}</b><br/>`;
                responseIsWarning.msgText += `${globalSettings?.messages?.pleaseTryAgain?.[languageObj?.id]}`;
                await sendMessageCloseCurrentWindowAsync({
                    msgType: responseIsWarning?.msgType,
                    msgText: !isUndNullEmp({ data: responseIsWarning?.msgHtml, subMethod: currentMethod, })?.result ? responseIsWarning?.msgHtml : responseIsWarning?.msgText,
                    closeWindow: false,
                    urlGoTo: '',
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            setElevator(elevatorLocal);

            //#region user get data
            if (processType === 2 && !isUndNullEmp({ data: elevatorLocal?.userId, subMethod: currentMethod, })?.result) {
                response = await userByIdGetAsync({
                    id: elevatorLocal?.userId,
                    auth: auth,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                user = !isUndNullEmp({ data: response?.result, subMethod: currentMethod, })?.result ? response?.result : {};
            } else {
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
            }
            //#endregion get user data

            //#region set process values
            setProcessValues({
                auth: auth,
                dtId: dtElevatorsId,
                rowIndex: rowIndex,
                showModal: false,
                setShowModal: null,
                type: processType,
                user: user,
            });
            //#endregion set process values

            //#endregion set initial values
            setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });

            setShowModalElevator(true);
        } catch (ex) {
            setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    const elevatorShowModalDeleteGetAsync = async ({ id_ = '', description = '', rowIndex = 0, subMethod = '', }) => {
        const currentMethod = 'elevatorShowModalDeleteGetAsync';
        let response = responseGet();
        try {
            //#region old code
            //#region show message
            // swalProperties = {
            //     icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
            //     title: globalSettings?.messages?.areYouSureDeleteThis?.[languageObj?.id],
            //     html: `${globalSettings?.labels?.elevator?.[languageObj?.id]}: <b>${description}</b><br/>${globalSettings?.messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            //     timer: null,
            //     confirmButtonColor: globalSettings?.colors?.warningColorExp,
            //     confirmButtonText: globalSettings?.labels?.yes?.[languageObj?.id],
            //     showCancelButton: true,
            //     cancelButtonColor: globalSettings?.colors?.successColorExp,
            //     cancelButtonText: globalSettings?.labels?.no?.[languageObj?.id],
            //     didOpen: () => {
            //         Swal.hideLoading();
            //     },
            // };

            // const { isConfirmed, } = await Swal.fire(swalProperties);
            //#endregion show message

            //#region delete data
            // if (isConfirmed) {
            //     setShowLoading({ building: false, floorsParkingStalls: false, elevators: true, inventory: false, commonArea: false, settings: false, });

            //     if (!isUndNullEmp({ data: building, subMethod: currentMethod, })?.result) {
            //         building.elevators = building?.elevators?.filter(({ id }) => id !== id_);
            //     }
            //     buildingTwo.elevators = buildingTwo?.elevators?.filter(({ id }) => id !== id_);

            //     headerObj = {
            //         headers: {
            //             authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
            //         },
            //     };
            //     dataObj = {
            //         elevators: buildingTwo.elevators,
            //     };

            //     //result = await axios?.post(`${globalSettings?.app?.backend?.urlDev}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlElevators}/${id}`, localData, headerObj);
            //     result = await axios?.post(`${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlElevators}/${id}`, dataObj, headerObj);
            //     response = result.data;

            //     if (!response?.isSuccess || response?.isWarning) {
            //         setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
            //         await sendMessageCloseCurrentWindowAsync({
            //             msgType: response?.msgType,
            //             msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
            //             closeWindow: false,
            //             urlGoTo: response?.urlGoTo,
            //             auth: auth,
            //             isLogout: false,
            //             languageId: languageObj?.id,
            //             subMethod: currentMethod,
            //         });
            //         return;
            //     }

            //     $(`#${dtElevatorsId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);
            //     sendMessage(0, globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id], 0, true, false, null, '');
            // }

            //#endregion delete data
            //#endregion old code

            //#region show message
            let msgTextObj = {
                one: `${globalSettings?.labels?.elevator?.[languageObj?.id]}: <b>${description}</b><br/>`,
                two: `${globalSettings?.messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };

            swalProperties = {
                icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
                title: globalSettings?.messages?.areYouSureDeleteThis?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: globalSettings?.colors?.warningColorExp,
                confirmButtonText: globalSettings?.labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: globalSettings?.colors?.successColorExp,
                cancelButtonText: globalSettings?.labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: globalSettings?.react?.sweetAlert2?.icons?.info,
                            title: `${globalSettings?.messages?.processing?.[languageObj?.id]}...`,
                            html: msgTextObj?.one,
                            showConfirmButton: false,
                        });
                        const buildingObj = {
                            one: building,
                            two: buildingTwo,
                        };

                        if (!isUndNullEmp({ data: buildingObj?.one, subMethod: currentMethod, })?.result) {
                            buildingObj.one.elevators = buildingObj?.one?.elevators?.filter(({ id }) => id !== id_);
                        }
                        buildingObj.two.elevators = buildingObj?.two?.elevators?.filter(({ id }) => id !== id_);

                        //#region delete data (elevator)
                        headerObj = {
                            headers: {
                                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                            },
                        };
                        dataObj = {
                            elevators: buildingObj?.two?.elevators,
                            languageId: languageObj?.id,
                            url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlElevators}/${id}`,
                        };

                        result = await axios?.post(
                            dataObj?.url,
                            dataObj,
                            headerObj,
                        );
                        response = result.data;

                        if (!response?.isSuccess || response?.isWarning) {
                            //controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: (isUndNullEmp({ data: response?.msgTextHtml, subMethod: currentMethod })?.result ? response?.msgText : response?.msgTextHtml),
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                            });
                            return;
                        }
                        //#endregion delete data (elevator)

                        //#region delete dataTable (elevator)
                        building.elevators = buildingObj?.one?.elevators
                        buildingTwo.elevators = buildingObj?.two?.elevators

                        $(`#${dtElevatorsId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);

                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id],
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });

                        //#region old code
                        // //Swal?.hideLoading();
                        // Swal?.update({
                        //     icon: globalSettings?.react?.sweetAlert2?.icons?.success,
                        //     title: globalSettings?.react?.sweetAlert2?.icons?.success,
                        //     html: globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id],
                        //     confirmButtonColor: globalSettings?.colors?.successColorExp,
                        //     showConfirmButton: true,
                        //     allowOutsideClick: true,
                        // });

                        // Swal?.hideLoading();
                        // await awaitDelay({ delayTimer: globalSettings?.timers?.tenSeconds, });
                        //#endregion old code
                        //#endregion delete dataTable (elevator)
                    } catch (ex) {
                        //#region Error
                        response.isSuccess = false;
                        response.msgType = -1;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        response.msgText += `Error: ${ex?.message}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion Error
                    }
                },
                allowOutsideClick: () => !Swal.isLoading(),
            };

            Swal.fire(swalProperties);
            //#endregion show message
        } catch (ex) {
            //controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }
    //#endregion elevators (methods)

    //#region inventory (methods)
    const dataTableInventorySet = ({ subMethod = '', }) => {
        const currentMethod = 'dataTableInventorySet';
        let response = responseGet();
        try {
            //dtInvntories = $(`#${dtInventoriesId}`)?.DataTable({
            $(`#${dtInventoriesId}`)?.DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: globalSettings?.labels?.description?.[languageObj?.id], width: '55%', },
                    { title: globalSettings?.labels?.type?.[languageObj?.id], width: '10%', },
                    { title: globalSettings?.labels?.brand?.[languageObj?.id], width: '15%', },
                    { title: globalSettings?.labels?.model?.[languageObj?.id], width: '15%', },
                    { title: globalSettings?.labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
            //.buttons().container().appendTo(`#${dtInventoriesId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const inventoryAddGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'inventoryAddGetAsync';
        let response = responseGet();
        try {
            controlsStatusSet({ processType: 5, subMethod: currentMethod, });

            //#region set initial data 
            setInventory(inventoryModelGet({
                id: uuidv4(),
                userId: auth?.user?.uid,
            }));

            //#region set process values
            setProcessValues({
                auth: auth,
                dtId: dtInventoriesId,
                rowIndex: 0,
                showModal: false,
                setShowModal: null,
                type: 0,
                user: {},
            });
            //#endregion set process values
            //#endregion set initial data 

            await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
            setShowModalInventory(true);
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    const inventoryEditDetailsGetAsync = async ({ id_ = '', description = '', rowIndex = 0, processType = 0, subMethod = '', }) => {
        const currentMethod = 'inventoryEditDetailsGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let user = {};
            let inventoryLocal = inventoryModelGet({});
            //#endregion variables

            setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: true, commonArea: false, settings: false, });

            //#region set initial data
            if (isUndNullEmp({ data: buildingTwo?.inventories, subMethod: currentMethod, })?.result) {
                setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: globalSettings?.messages?.youMustCreateLeastOneInventory?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: '',
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            inventoryLocal = buildingTwo?.inventories?.find(({ id }) => id === id_);

            if (isUndNullEmp({ data: inventoryLocal, subMethod: currentMethod, })?.result) {
                setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
                response.msgText = `${globalSettings?.messages?.theRecordCannotBeLocated?.[languageObj?.id]}:<br/>`;
                response.msgText += `<b>${description}</b><br/>`;
                response.msgText += `${globalSettings?.messages?.pleaseTryAgain?.[languageObj?.id]}`;
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            setInventory(inventoryLocal);

            //#region user get data
            if (processType === 2 && !isUndNullEmp({ data: inventoryLocal?.userId, subMethod: currentMethod, })?.result) {
                response = await userByIdGetAsync({
                    id: inventoryLocal?.userId,
                    auth: auth,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                user = !isUndNullEmp({ data: response?.result, subMethod: currentMethod, })?.result ? response?.result : {};
            }
            //#endregion get user data

            //#region set process values
            setProcessValues({
                auth: auth,
                dtId: dtInventoriesId,
                rowIndex: rowIndex,
                showModal: false,
                setShowModal: null,
                type: processType,
                user: user,
            });
            //#endregion set process values
            //#endregion set initial data

            await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond });
            setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
            setShowModalInventory(true);
        } catch (ex) {
            setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    const inventoryShowModalDeleteGetAsync = async ({ id_ = '', description = '', rowIndex = 0, subMethod = '', }) => {
        const currentMethod = 'inventoryShowModalDeleteGetAsync';
        let response = responseGet();
        try {
            //#region show message
            let msgTextObj = {
                one: `${globalSettings?.labels?.inventory?.[languageObj?.id]}: <b>${description}</b><br/>`,
                two: `${globalSettings?.messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };

            swalProperties = {
                icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
                title: globalSettings?.messages?.areYouSureDeleteThis?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: globalSettings?.colors?.warningColorExp,
                confirmButtonText: globalSettings?.labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: globalSettings?.colors?.successColorExp,
                cancelButtonText: globalSettings?.labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: globalSettings?.react?.sweetAlert2?.icons?.info,
                            title: `${globalSettings?.messages?.processing?.[languageObj?.id]}...`,
                            html: msgTextObj?.one,
                            showConfirmButton: false,
                        });
                        const buildingObj = {
                            one: building,
                            two: buildingTwo,
                        };

                        if (!isUndNullEmp({ data: buildingObj?.one, subMethod: currentMethod, })?.result) {
                            buildingObj.one.inventories = buildingObj?.one?.inventories?.filter(({ id }) => id !== id_);
                        }
                        buildingObj.two.inventories = buildingObj?.two?.inventories?.filter(({ id }) => id !== id_);

                        //#region delete data (elevator)
                        headerObj = {
                            headers: {
                                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                            },
                        };
                        dataObj = {
                            inventories: buildingObj?.two?.inventories,
                            languageId: languageObj?.id,
                            url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlInventories}/${id}`,
                        };

                        result = await axios?.post(
                            dataObj?.url,
                            dataObj,
                            headerObj,
                        );
                        response = result.data;

                        if (!response?.isSuccess || response?.isWarning) {
                            //controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: (isUndNullEmp({ data: response?.msgTextHtml, subMethod: currentMethod })?.result ? response?.msgText : response?.msgTextHtml),
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                            });
                            return;
                        }
                        //#endregion delete data (elevator)

                        //#region delete dataTable (elevator)
                        building.inventories = buildingObj?.one?.inventories
                        buildingTwo.inventories = buildingObj?.two?.inventories

                        $(`#${dtInventoriesId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);

                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id],
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });

                        //#region old code
                        // //Swal?.hideLoading();
                        // Swal?.update({
                        //     icon: globalSettings?.react?.sweetAlert2?.icons?.success,
                        //     title: globalSettings?.react?.sweetAlert2?.icons?.success,
                        //     html: globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id],
                        //     confirmButtonColor: globalSettings?.colors?.successColorExp,
                        //     showConfirmButton: true,
                        //     allowOutsideClick: true,
                        // });

                        // Swal?.hideLoading();
                        // await awaitDelay({ delayTimer: globalSettings?.timers?.tenSeconds, });
                        //#endregion old code
                        //#endregion delete dataTable (elevator)
                    } catch (ex) {
                        //#region Error
                        response.isSuccess = false;
                        response.msgType = -1;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        response.msgText += `Error: ${ex?.message}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion Error
                    }
                },
                allowOutsideClick: () => !Swal.isLoading(),
            };

            Swal.fire(swalProperties);
            //#endregion show message
        } catch (ex) {
            //controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }
    //#endregion inventory (methods)

    //#region Common areas (methods)
    const dataTableCommonAreasSet = ({ subMethod = '', }) => {
        const currentMethod = 'dataTableCommonAreasSet';
        let response = responseGet();
        try {
            //dtInvntories = $(`#${dtInventoriesId}`)?.DataTable({
            $(`#${dtCommonAreasId}`)?.DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: globalSettings?.labels?.commonArea?.[languageObj?.id], width: '95%', },
                    { title: globalSettings?.labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
            //.buttons().container().appendTo(`#${dtInventoriesId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const commonAreaAddEditDeleteAsync = async ({ id_ = '', description = '', rowIndex = 0, processType = 0, subMethod = '', }) => {
        const currentMethod = 'commonAreaAddEditDeleteAsync';
        let response = responseGet();
        try {
            //#region variables
            let userLocal = {};
            let commonAreasBeforeLocal = [];
            const showModalLocal = processType > -1;
            let commonAreaLocal = commonAreaModelGet({});
            //#endregion variables

            if (showModalLocal) {
                if (processType === 0) {
                    controlsStatusSet({ processType: 6, subMethod: currentMethod, });
                } else {
                    setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: true, settings: false, });
                }
            } else {
                //setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: true, settings: false, });
            }

            //#region check process
            if (processType === -1) {
                //#region delete
                // //#region show message
                // swalProperties = {
                //     icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
                //     title: globalSettings?.messages?.areYouSureDeleteThis?.[languageObj?.id],
                //     html: `${globalSettings?.labels?.commonArea?.[languageObj?.id]}: <b>${description}</b><br/>${globalSettings?.messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
                //     timer: null,
                //     confirmButtonColor: globalSettings?.colors?.warningColorExp,
                //     confirmButtonText: globalSettings?.labels?.yes?.[languageObj?.id],
                //     showCancelButton: true,
                //     cancelButtonColor: globalSettings?.colors?.successColorExp,
                //     cancelButtonText: globalSettings?.labels?.no?.[languageObj?.id],
                //     didOpen: () => {
                //         Swal.hideLoading();
                //     },
                // };

                // const { isConfirmed, } = await Swal.fire(swalProperties);
                // //#endregion show message

                // //#region delete data
                // if (isConfirmed) {
                //     sendMessage(2, globalSettings?.messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

                //     if (!isUndefined(building) && !isNull(building) && !isEmpty(building)) {
                //         //building.commonAreas = building.commonAreas.filter(({ id }) => id !== commonAreaId);
                //         building.commonAreas = buildingTwo.commonAreas.filter(({ id }) => id !== id_);
                //     }
                //     commonAreasBeforeLocal = buildingTwo.commonAreas;

                //     //#region Common area delete

                //     commonAreaLocal = buildingTwo?.commonAreas?.filter(({ id, }) => id === id_);
                //     commonAreaLocal = Array?.isArray(commonAreaLocal) ? commonAreaLocal?.[0] : commonAreaLocal;

                //     //#endregion Common area delete
                //     buildingTwo.commonAreas = buildingTwo.commonAreas.filter(({ id }) => id !== id_);

                //     headerObj = {
                //         headers: {
                //             authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                //         },
                //     };
                //     dataObj = {
                //         commonAreas: buildingTwo.commonAreas,
                //         commonArea: commonAreaLocal,
                //         isDelete: true,
                //     };
                //     //result = await axios?.post(`${globalSettings?.app?.backend?.urlDev}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlCommonAreas}/${id}`, localData, headerObj);
                //     result = await axios?.post(`${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlCommonAreas}/${id}`, dataObj, headerObj);
                //     response = result.data;

                //     if (!response?.isSuccess || response?.isWarning) {
                //         buildingTwo.commonAreas = commonAreasBeforeLocal;
                //         //building.commonAreas = localCommonAreas;
                //         await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
                //         return;
                //     }

                //     $(`#${dtCommonAreasId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);
                //     sendMessage(0, globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id], 0, true, false, null, '');
                // }
                // //#endregion delete data

                // return response;
                //#endregion delete

                //#region show message
                let msgTextObj = {
                    one: `${globalSettings?.labels?.commonArea?.[languageObj?.id]}: <b>${description}</b><br/>`,
                    two: `${globalSettings?.messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
                };

                swalProperties = {
                    icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
                    title: globalSettings?.messages?.areYouSureDeleteThis?.[languageObj?.id],
                    html: `${msgTextObj?.one}${msgTextObj?.two}`,
                    timer: null,
                    backdrop: true,
                    confirmButtonColor: globalSettings?.colors?.warningColorExp,
                    confirmButtonText: globalSettings?.labels?.yes?.[languageObj?.id],
                    showCancelButton: true, //!Swal.isLoading(), //true,
                    cancelButtonColor: globalSettings?.colors?.successColorExp,
                    cancelButtonText: globalSettings?.labels?.no?.[languageObj?.id],
                    showLoaderOnConfirm: true,
                    didOpen: () => {
                        Swal.hideLoading();
                    },
                    preConfirm: async () => {
                        try {
                            Swal.getCancelButton().hidden = true;
                            Swal?.update({
                                icon: globalSettings?.react?.sweetAlert2?.icons?.info,
                                title: `${globalSettings?.messages?.processing?.[languageObj?.id]}...`,
                                html: msgTextObj?.one,
                                showConfirmButton: false,
                            });
                            const buildingObj = {
                                one: building,
                                two: buildingTwo,
                            };

                            if (!isUndNullEmp({ data: buildingObj?.one, subMethod: currentMethod, })?.result) {
                                buildingObj.one.commonAreas = buildingObj?.one?.commonAreas?.filter(({ id }) => id !== id_);
                            }

                            commonAreasBeforeLocal = buildingObj?.two?.commonAreas;

                            //#region Common area delete
                            commonAreaLocal = buildingObj?.two?.commonAreas?.filter(({ id, }) => id === id_);
                            commonAreaLocal = Array?.isArray(commonAreaLocal) ? commonAreaLocal?.[0] : commonAreaLocal;
                            //#endregion Common area delete

                            buildingObj.two.commonAreas = buildingObj?.two?.commonAreas?.filter(({ id }) => id !== id_);

                            //#region delete data (commonArea)
                            headerObj = {
                                headers: {
                                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                                },
                            };
                            dataObj = {
                                commonAreas: buildingObj?.two?.commonAreas,
                                commonArea: commonAreaLocal,
                                isDelete: true,
                                languageId: languageObj?.id,
                                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlCommonAreas}/${id}`,
                            };

                            result = await axios?.post(
                                dataObj?.url,
                                dataObj,
                                headerObj,
                            );
                            response = result.data;

                            if (!response?.isSuccess || response?.isWarning) {
                                buildingTwo.commonAreas = commonAreasBeforeLocal;
                                await sendMessageCloseCurrentWindowAsync({
                                    msgType: response?.msgType,
                                    msgText: (isUndNullEmp({ data: response?.msgTextHtml, subMethod: currentMethod })?.result ? response?.msgText : response?.msgTextHtml),
                                    closeWindow: false,
                                    urlGoTo: response?.urlGoTo,
                                    auth: auth,
                                    isLogout: false,
                                    languageId: languageObj?.id,
                                });
                                return;
                            }
                            //#endregion delete data (commonArea)

                            //#region delete dataTable (commonArea)
                            building.commonAreas = buildingObj?.one?.commonAreas;
                            buildingTwo.commonAreas = buildingObj?.two?.commonAreas;

                            $(`#${dtCommonAreasId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);

                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id],
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                            });
                            return;

                            //#region old code
                            // //Swal?.hideLoading();
                            // Swal?.update({
                            //     icon: globalSettings?.react?.sweetAlert2?.icons?.success,
                            //     title: globalSettings?.react?.sweetAlert2?.icons?.success,
                            //     html: globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id],
                            //     confirmButtonColor: globalSettings?.colors?.successColorExp,
                            //     showConfirmButton: true,
                            //     allowOutsideClick: true,
                            // });

                            // Swal?.hideLoading();
                            // await awaitDelay({ delayTimer: globalSettings?.timers?.tenSeconds, });
                            //#endregion old code
                            //#endregion delete dataTable (commonArea)
                        } catch (ex) {
                            //#region Error
                            response.isSuccess = false;
                            response.msgType = -1;
                            response.msgText = `Method: ${currentMethod}<br/>`;
                            response.msgText += `Error: ${ex?.message}`;
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                            });
                            //#endregion Error
                        }
                    },
                    allowOutsideClick: () => !Swal.isLoading(),
                };

                Swal.fire(swalProperties);
                //#endregion show message
            } else if (processType === 0) {
                //#region New
                setCommonArea(commonAreaModelGet({
                    id: uuidv4(),
                    userId: auth?.user?.uid,
                }));
                //#endregion New
            } else if (processType > 0) {
                //#region Edit / detail
                if (isUndNullEmp({ data: buildingTwo?.commonAreas, subMethod: currentMethod, })?.result) {
                    //setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: 1,
                        msgText: globalSettings?.messages?.youMustCreateLeastOneCommonArea?.[languageObj?.id],
                        closeWindow: false,
                        urlGoTo: '',
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }

                commonAreaLocal = buildingTwo?.commonAreas?.find(({ id }) => id === id_);

                if (isUndNullEmp({ data: commonAreaLocal, subMethod: currentMethod, })?.result) {
                    //setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
                    response.msgText = `${globalSettings?.messages?.theRecordCannotBeLocated?.[languageObj?.id]}:<br/>`;
                    response.msgText += `<b>${description}</b><br/>`;
                    response.msgText += `${globalSettings?.messages?.pleaseTryAgain?.[languageObj?.id]}`;
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: 1,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: '',
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }

                setCommonArea(commonAreaLocal);

                //#region user get
                if (processType === 2) {
                    response = await userByIdGetAsync({
                        id: commonAreaLocal?.userId,
                        auth: auth,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });

                    if (!response?.isSuccess || response?.isWarning) {
                        setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    userLocal = response.result;
                }
                //#endregion get user
                //#endregion Edit /detail
            }
            //#endregion check process

            //#region set process values
            setProcessValues({
                auth: auth,
                dtId: dtCommonAreasId,
                rowIndex: rowIndex,
                showModal: showModalLocal,
                setShowModal: setCommonAreaShowModal,
                type: processType,
                user: userLocal,
            });
            //#endregion set process values

            if (showModalLocal) {
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                setCommonAreaShowModal(showModalLocal);
                if (processType === 0) {
                    controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                } else {
                    setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
                }
            } else {
                setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
            }
        } catch (ex) {
            setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
            setCommonAreaShowModal(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }
    //#endregion Common areas (methods)

    //#region settings
    const buildingSettingsDataSet = async ({ e = {}, processType = '', subMethod = '', }) => {
        const currentMethod = 'buildingSettingsDataSet';
        let response = responseGet();
        try {
            //#region old code
            // building.globalSettings.accountsReceivable.aliquotPercentage = e?.target?.checked;
            // formDataSet(globalSettings?.collections?.properties?.settings, building.settings);
            //#endregion old code

            //#region process
            switch (processType) {
                case processName?.accountsReceivableAliquotPercentage:
                    //#region old code
                    //building.settings.accountsReceivable.aliquotPercentage = e?.target?.checked;
                    //#endregion old code
                    if (isUndNullEmp({ data: building?.settings?.accountsReceivable?.aliquotPercentage, subMethod: currentMethod, })?.result) {
                        building.settings = buildingModelGet({})?.settings;
                    }

                    building.settings.accountsReceivable.aliquotPercentage = e?.target?.checked;
                    break;
                case processName?.usersMaxLockoutAttemps:
                    //#region old code
                    // building.settings.users.maxLockoutAttemps = numberSet({
                    //     number: e?.target?.value,
                    //     type: 'i',
                    //     languageId: languageObj?.id,
                    //     subMethod: currentMethod,
                    // })?.result;
                    //#endregion old code
                    if (isUndNullEmp({ data: building?.settings?.users?.maxLockoutAttemps, subMethod: currentMethod, })?.result) {
                        building.settings = buildingModelGet({})?.settings;
                    }

                    building.settings.users.maxLockoutAttemps = numberSet({
                        number: e?.target?.value,
                        type: 'i',
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result;
                    break;
                default:
                    break;
            }

            formDataSet({ property: globalSettings?.collections?.properties?.settings, value: building?.settings, subMethod: currentMethod, });
            //#endregion process
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    const buildingSettingsEditAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'buildingSettingsEditAsync';
        let response = responseGet();
        try {
            e.preventDefault();

            setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: true, });

            //#region process
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };
            dataObj = {
                settings: building.settings,
                languageId: languageObj?.id,
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlBuildingSettings}/${building.id}`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result.data;

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion process

            //#region data set
            buildingTwo = response?.result;
            setBuilding(buildingTwo);
            //#endregion data set

            setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: '',
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        } catch (ex) {
            setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }
    //#endregion settings

    //#region methods (others)
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //setShowLoading(true);
            //setShowData(false);

            //#region variables
            let buildingLocal = {};
            let isEditLocal = false;
            let isDeleteLocal = false;
            //#endregion variables

            //#region initialize
            elevators = [];
            inventories = [];
            commonAreas = [];
            //#endregion initialize

            //#region check role user
            //#region old code
            // if (userRole === '') {
            //     //history.push('/');
            //     //setShowLoading(false);
            //     //setShowData(false);
            //     await sendMessageCloseCurrentWindowAsync(1, globalSettings?.messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess?.[languageObj?.id], false, globalSettings?.app?.backend?.urlHome, auth, false);
            // }
            //#endregion old code
            //#endregion check role user

            //#region dataTables set
            response = dataTablesSet({
                dtElevators: true,
                dtInventories: true,
                dtCommonAreas: true,
                _queryCodeSet: true,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) {
                //setShowLoading(false);
                //setShowData(false);
                setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion dataTables set

            //#region data get
            //#region get coins
            //#region old code
            // headerObj = {
            //     headers: {
            //         authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
            //     },
            // };

            // localData = {
            //     conditionals: [
            //         { field: globalSettings?.collections?.properties?.buildingId, operator: globalSettings?.react?.firebase?.operators?.equalTo, value: `${id}`, },
            //     ],
            //     ordersBy: [
            //         { field: globalSettings?.collections?.properties?.description, value: 'asc', },
            //     ],
            //     buildingId: id,
            // };

            // //result = await axios?.post(`${globalSettings?.app?.backend?.urlDev}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlCoins}/`, localData, headerObj);
            // result = await axios?.post(`${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlCoins}/`, localData, headerObj);
            // response = result.data;

            // if (!response?.isSuccess || response?.isWarning) {
            //     //setShowLoading(false);
            //     //setShowData(false);
            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //     return;
            // }

            // if (isUndefined(response.result) || isNull(response.result) || response.result.length <= 0) {
            //     //setShowLoading(false);
            //     //setShowData(false);
            //     response.msgText = `${globalSettings?.messages?.youMustCreateLeastOneCoin?.[languageObj?.id]}<br/>`;
            //     response.msgText += `${globalSettings?.messages?.goTo?.[languageObj?.id]}: <i class='${globalSettings?.icons?.coins}'></i> `;
            //     response.msgText += `<a href='${globalSettings?.app?.backend?.urlCoins}'>${globalSettings?.labels?.coins?.[languageObj?.id]}</a>`;
            //     await sendMessageCloseCurrentWindowAsync(response.msgType, response.msgText, false, globalSettings?.app?.backend?.urlBuildings, auth);
            //     return;
            // }
            // setCoins(response.result);
            //#endregion old code

            response = await validationCoinGetAsync({
                buildingId: id,
                limit: 0,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                //setShowLoading(false);
                //setShowData(false);
                //controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            setCoins(response?.result);
            //#endregion get coins

            //#region building get
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    languageId: languageObj?.id,
                },
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlBuildings}/${id}`,
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj,
            );

            response = result.data;

            if (!response?.isSuccess || response?.isWarning) {
                //setShowLoading(false);
                //setShowData(false);
                //controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            buildingLocal = response?.result;
            setBuilding(buildingLocal);
            buildingTwo = buildingLocal;

            //#region set edit, delete, detail
            isEditLocal = processEvaluateGet({
                object: buildingLocal,
                property: globalSettings?.labels?.process?.en?.toLowerCase(),
                process: globalSettings?.labels?.edit?.en?.toLowerCase(),
                subMethod: currentMethod
            })?.result;

            isDeleteLocal = isEditLocal;

            setIsEditDelete(!(isEditLocal && isDeleteLocal));
            //#endregion set edit, delete, detail

            //#region control data set
            //#region old code
            // //response = dateInControlSetAsync(new Date(), localBuilding.contractDate);
            // response = dateInControlSetAsync(new Date(), null);
            // if (!response?.isSuccess || response?.isWarning) {
            //     //setShowLoading(false);
            //     //setShowData(false);
            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth);
            //     return;
            // }
            //#endregion old code
            //#endregion control data set

            //#region load elevators
            if (!isUndNullEmp({ data: buildingLocal?.elevators, subMethod: currentMethod, })?.result && buildingLocal?.elevators?.length > 0) {
                buildingLocal?.elevators?.map((detail) => (
                    elevators.push([
                        detail?.description,
                        elevatorGetType({ data: detail, subMethod: currentMethod, })?.result,
                        detail?.brand,
                        detail?.model,
                        buttonProcessGet({
                            id: detail?.id,
                            description: detail?.description,
                            showDetails: true,
                            labelDetails: globalSettings?.labels?.detail?.[languageObj?.id],
                            enabledDetails: true,
                            showEdit: true,
                            labelEdit: globalSettings?.labels?.edit?.[languageObj?.id],
                            enabledEdit: true,
                            showDelete: true,
                            labelDelete: globalSettings?.labels?.delete?.[languageObj?.id],
                            enabledDelete: true,
                            processButtons: [],
                            subMethod: currentMethod,
                        })?.result
                    ])
                ));
            }
            //#endregion load elevators

            //#region load inventories
            if (!isUndNullEmp({ data: buildingLocal?.inventories, subMethod: currentMethod, })?.result && buildingLocal?.inventories?.length > 0) {
                buildingLocal?.inventories?.map((detail) => (
                    inventories?.push([
                        detail?.description,
                        detail?.type,
                        detail?.brand,
                        detail?.model,
                        buttonProcessGet({
                            id: detail?.id,
                            description: detail?.description,
                            showDetails: true,
                            labelDetails: globalSettings?.labels?.detail?.[languageObj?.id],
                            enabledDetails: true,
                            showEdit: true,
                            labelEdit: globalSettings?.labels?.edit?.[languageObj?.id],
                            enabledEdit: true,
                            showDelete: true,
                            labelDelete: globalSettings?.labels?.delete?.[languageObj?.id],
                            enabledDelete: true,
                            processButtons: [],
                            subMethod: currentMethod,
                        })?.result,
                    ])
                ));
            }
            //#endregion load inventories

            //#region load common area
            if (!isUndNullEmp({ data: buildingLocal?.commonAreas, subMethod: currentMethod, })?.result && buildingLocal?.commonAreas?.length > 0) {
                buildingLocal?.commonAreas?.map((detail) => (
                    commonAreas?.push([
                        detail.area,
                        buttonProcessGet({
                            id: detail?.id,
                            description: detail?.area,
                            showDetails: true,
                            labelDetails: globalSettings?.labels?.detail?.[languageObj?.id],
                            enabledDetails: true,
                            showEdit: true,
                            labelEdit: globalSettings?.labels?.edit?.[languageObj?.id],
                            enabledEdit: true,
                            showDelete: true,
                            labelDelete: globalSettings?.labels?.delete?.[languageObj?.id],
                            enabledDelete: true,
                            processButtons: [],
                            subMethod: currentMethod,
                        })?.result,
                    ])
                ));
            }
            //#endregion load common area

            //#region calculate total apartments
            response = calculateTotalApartments({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                //setShowLoading(false);
                //setShowData(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion calculate total apartments
            //#endregion building get
            //#endregion data get

            //setShowLoading(false);
            //setShowData(true);

            //#region old code
            // //#region dataTables set / Add data in DataTable
            // response = dataTablesSet(true, true, true, true);
            // if (!response?.isSuccess || response?.isWarning) {
            //     //setShowLoading(false);
            //     //setShowData(false);
            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth);
            //     return;
            // }

            // $(`#${dtElevatorsId}`)?.DataTable()?.rows?.add(elevators)?.draw(true);
            // $(`#${dtInventoriesId}`)?.DataTable()?.rows?.add(inventories)?.draw(true);
            // $(`#${dtCommonAreasId}`)?.DataTable()?.rows?.add(commonAreas)?.draw(true);
            // //#endregion dataTables set / Add data in DataTable
            //#endregion old code

            //#region add data in DataTable
            $(`#${dtElevatorsId}`)?.DataTable()?.rows?.add(elevators)?.draw(true);
            $(`#${dtInventoriesId}`)?.DataTable()?.rows?.add(inventories)?.draw(true);
            $(`#${dtCommonAreasId}`)?.DataTable()?.rows?.add(commonAreas)?.draw(true);
            //#endregion add data in DataTable

            setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
        } catch (ex) {
            //controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    const dataTablesSet = ({ dtElevators = false, dtInventories = false, dtCommonAreas = false, _queryCodeSet = false, subMethod = '', }) => {
        const currentMethod = 'dataTablesSet';
        let response = responseGet();
        try {
            if (dtElevators) {
                response = dataTableElevatorsSet({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
            }

            if (dtInventories) {
                response = dataTableInventorySet({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
            }

            if (dtCommonAreas) {
                response = dataTableCommonAreasSet({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
            }

            if (_queryCodeSet) {
                response = queryCodeSet({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const queryCodeSet = ({ subMethod = '', }) => {
        const currentMethod = 'queryCodeSet';
        let response = responseGet();
        try {
            //#region variables
            let rowIndex = 0;
            let dtRowIndex = 0;
            let methodName = '';
            let id = '';
            let description = '';
            //#endregion variables

            //#region data table (Elevators)
            $(`#${dtElevatorsId} tbody`)?.on('click', 'tr', 'td', async function (e) {
                e.preventDefault();
                rowIndex = $(`#${dtElevatorsId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = (!isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex);
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    methodName = e?.target?.attributes?.method?.value || '';
                    id = e?.target?.attributes?.id?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (methodName) {
                        case 'edit':
                            elevatorEditDetailsGetAsync({ id_: id, description: description, rowIndex: dtRowIndex, processType: 1, subMethod: currentMethod, });
                            break;
                        case 'details':
                            elevatorEditDetailsGetAsync({ id_: id, description: description, rowIndex: dtRowIndex, processType: 2, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            elevatorShowModalDeleteGetAsync({ id_: id, description: description, rowIndex: dtRowIndex, subMethod: currentMethod });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion data table (Elevators)

            //#region data table (iventories)
            $(`#${dtInventoriesId} tbody`)?.on('click', 'tr', 'td', async function (e) {
                e.preventDefault();
                rowIndex = $(`#${dtInventoriesId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = (!isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex);
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    methodName = e?.target?.attributes?.method?.value || '';
                    id = e?.target?.attributes?.id?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (methodName) {
                        case 'edit':
                            inventoryEditDetailsGetAsync({ id_: id, description: description, rowIndex: dtRowIndex, processType: 1, subMethod: currentMethod, });
                            break;
                        case 'details':
                            inventoryEditDetailsGetAsync({ id_: id, description: description, rowIndex: dtRowIndex, processType: 2, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            inventoryShowModalDeleteGetAsync({ id_: id, description: description, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion data table (iventories)

            //#region data table (common areas)
            $(`#${dtCommonAreasId} tbody`)?.on('click', 'tr', 'td', async function (e) {
                e.preventDefault();
                rowIndex = $(`#${dtCommonAreasId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = (!isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex);
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    methodName = e?.target?.attributes?.method?.value || '';
                    id = e?.target?.attributes?.id?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (methodName) {
                        case 'edit':
                            commonAreaAddEditDeleteAsync({ id_: id, description: description, rowIndex: dtRowIndex, processType: 1, subMethod: currentMethod, });
                            break;
                        case 'details':
                            commonAreaAddEditDeleteAsync({ id_: id, description: description, rowIndex: dtRowIndex, processType: 2, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            commonAreaAddEditDeleteAsync({ id_: id, description: description, rowIndex: dtRowIndex, processType: -1, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion data table (common areas)
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    //#region buttons
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.removeClass();

                    $(`#${controls?.icons?.contract?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.contract?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.contract?.id}`)?.removeClass();

                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.removeClass();


                    $(`#${controls?.icons?.save?.id}`)?.addClass(controls?.icons?.save.className);
                    $(`#${controls?.buttons?.save?.id}`)?.addClass(controls?.buttons?.save?.className);
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(controls?.spinners?.save.className);

                    $(`#${controls?.icons?.contract?.id}`)?.addClass(controls?.icons?.contract.className);
                    $(`#${controls?.buttons?.contract?.id}`)?.addClass(controls?.buttons?.contract?.className);
                    $(`#${controls?.spinners?.contract?.id}`)?.addClass(controls?.spinners?.contract.className);

                    $(`#${controls?.icons?.back?.id}`)?.addClass(controls?.icons?.back.className);
                    $(`#${controls?.buttons?.back?.id}`)?.addClass(controls?.buttons?.back?.className);
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(controls?.spinners?.back.className);
                    //#endregion buttons

                    //#region buttons (dataTables)
                    $(`#${controls?.dataTables?.elevators?.icons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.elevators?.buttons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.elevators?.spinners?.add?.id}`)?.removeClass();

                    $(`#${controls?.dataTables?.inventories?.icons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.inventories?.buttons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.inventories?.spinners?.add?.id}`)?.removeClass();

                    $(`#${controls?.dataTables?.commonAreas?.icons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.commonAreas?.buttons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.commonAreas?.spinners?.add?.id}`)?.removeClass();

                    $(`#${controls?.dataTables?.elevators?.icons?.add?.id}`)?.addClass(controls?.dataTables?.elevators?.icons?.add.className);
                    $(`#${controls?.dataTables?.elevators?.buttons?.add?.id}`)?.addClass(controls?.dataTables?.elevators?.buttons?.add?.className);
                    $(`#${controls?.dataTables?.elevators?.spinners?.add?.id}`)?.addClass(controls?.dataTables?.elevators?.spinners?.add.className);

                    $(`#${controls?.dataTables?.inventories?.icons?.add?.id}`)?.addClass(controls?.dataTables?.inventories?.icons?.add.className);
                    $(`#${controls?.dataTables?.inventories?.buttons?.add?.id}`)?.addClass(controls?.dataTables?.inventories?.buttons?.add?.className);
                    $(`#${controls?.dataTables?.inventories?.spinners?.add?.id}`)?.addClass(controls?.dataTables?.inventories?.spinners?.add.className);

                    $(`#${controls?.dataTables?.commonAreas?.icons?.add?.id}`)?.addClass(controls?.dataTables?.commonAreas?.icons?.add.className);
                    $(`#${controls?.dataTables?.commonAreas?.buttons?.add?.id}`)?.addClass(controls?.dataTables?.commonAreas?.buttons?.add?.className);
                    $(`#${controls?.dataTables?.commonAreas?.spinners?.add?.id}`)?.addClass(controls?.dataTables?.commonAreas?.spinners?.add.className);
                    //#endregion buttons (dataTables)
                    break;
                case 1:
                    //$(`#${controls?.buttons?.create?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${globalSettings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.contract?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.contract?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 3:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 4:
                    $(`#${controls?.dataTables?.elevators?.icons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.elevators?.spinners?.add?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 5:
                    $(`#${controls?.dataTables?.inventories?.icons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.inventories?.spinners?.add?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 6:
                    $(`#${controls?.dataTables?.commonAreas?.icons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.commonAreas?.spinners?.add?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region inputs
            $(`#${controls?.inputs?.description?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.year?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.email?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.address?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.contract?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.apartmentsPerTopLevel?.id}`).attr('disabled', (processType !== 0));
            $(`#${controls?.inputs?.floors?.id}`).attr('disabled', (processType !== 0));
            $(`#${controls?.inputs?.apartmentsPerFloor?.id}`).attr('disabled', (processType !== 0));
            $(`#${controls?.inputs?.apartmentsPerLowLevel?.id}`).attr('disabled', (processType !== 0));
            $(`#${controls?.inputs?.parkingStalls?.id}`).attr('disabled', (processType !== 0));
            //#endregion inputs

            //#region Selects
            $(`#${controls?.selects?.coinBase?.id}`).attr('disabled', (processType !== 0));
            $(`#${controls?.selects?.coinOther?.id}`).attr('disabled', (processType !== 0));
            //#endregion Selects

            //#region checkBoxes
            $(`#${controls?.checkBox?.topLevel?.id}`).attr('disabled', (processType !== 0));
            $(`#${controls?.checkBox?.lowLevel?.id}`).attr('disabled', (processType !== 0));
            //#endregion checkBoxes

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTables
            $(`#${controls?.dataTables?.elevators?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.elevators?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            $(`#${controls?.dataTables?.inventories?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.inventories?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            $(`#${controls?.dataTables?.commonAreas?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.commonAreas?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            //#endregion dataTables

            //#region Buttons
            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.contract?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);

                $(`#${controls?.dataTables?.elevators?.buttons?.add?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.dataTables?.inventories?.buttons?.add?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.dataTables?.commonAreas?.buttons?.add?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
            }
            //#endregion Buttons
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'onLoad - form', });
    }, [id]) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            <Menu viewName='process' process='buildings' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{globalSettings?.labels?.building?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{globalSettings?.labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item'><Link to={globalSettings?.app?.backend?.urlBuildings}>{globalSettings?.labels?.buildings?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{globalSettings?.labels?.building?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        <div className='row'>
                            <div className='col-12'>

                                <form onSubmit={(e) => buildingEditPostAsync({ e: e, subMethod: 'form - sumit', })}>
                                    {/*building*/}
                                    <div className='card card-outline card-primary shadow-lg'>
                                        <LoadingSection alt='loadingSection'
                                            className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                            showText={true}
                                            text={globalSettings?.messages?.processing?.[languageObj?.id]}
                                            height={25}
                                            hidden={!showLoading?.building}
                                            width={25}
                                            languageId={languageObj?.id}
                                            subMethod={currentMethod} />

                                        {/*card header*/}
                                        <div className='card-header'>
                                            <h6 className='card-title'>
                                                <img alt={globalSettings?.labels?.buildings?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.buildingsLogo}></img> - {globalSettings?.labels?.edit?.[languageObj?.id]}
                                            </h6>
                                            <div className='card-tools'>
                                                <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                    <i className={globalSettings?.icons?.minus}></i>
                                                </button>
                                                {/* <button tooltip='tooltip' title={globalSettings?.labels?.create?.[languageObj?.id]} className='btn btn-outline-success float-right btn-sm' onClick={()=> elevatorAddGetAsync()}><i className={globalSettings?.icons?.plusCircle}></i></button> */}
                                            </div>
                                        </div>

                                        {/*card body*/}
                                        <div className='card-body'>
                                            {/* {!isUndefined(building) && !isNull(building) && !isEmpty(building) ?
                                                <div> */}
                                            {/*building data*/}
                                            <div className='row'>
                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <input id={controls?.inputs?.description?.id}
                                                                className={controls?.inputs?.description?.className}
                                                                //autoFocus
                                                                placeholder={globalSettings?.labels?.name?.[languageObj?.id]}
                                                                onChange={(e) => formDataSet({ property: 'description', value: e?.target?.value, subMethod: 'input - description', })}
                                                                onFocus={() => setDescriptionError('')}
                                                                value={!isUndNullEmp({ data: building?.description, subMethod: currentMethod, })?.result ? building?.description : ''}
                                                                tooltip='tooltip' title={globalSettings?.labels?.name?.[languageObj?.id]} />
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className={globalSettings?.icons?.building} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(descriptionError)}</div>
                                                    </div>
                                                </div>

                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <input id={controls?.inputs?.year?.id}
                                                                className={controls?.inputs?.year?.className}
                                                                placeholder={globalSettings?.labels?.year?.[languageObj?.id]}
                                                                onChange={(e) => formDataSet({ property: 'year', value: e?.target?.value, subMethod: 'input - year', })}
                                                                onFocus={() => setYearError('')}
                                                                tooltip='tooltip' title={globalSettings?.labels?.year?.[languageObj?.id]}
                                                                type='number'
                                                                value={!isUndNullEmp({ data: building?.year, subMethod: currentMethod, })?.result && building?.year !== 0 ? building?.year : formDataSet({ property: 'year', value: new Date()?.getFullYear(), subMethod: 'input - year', })} />
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className={globalSettings?.icons?.sortNumericUpAlt} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(yearError)}</div>
                                                    </div>
                                                </div>

                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <input id={controls?.inputs?.email?.id}
                                                                className={controls?.inputs?.email?.className}
                                                                placeholder={globalSettings?.labels?.email?.[languageObj?.id]}
                                                                onChange={(e) => formDataSet({ property: 'email', value: e?.target?.value, subMethod: 'input - email', })}
                                                                onFocus={() => setEmailError('')}
                                                                tooltip='tooltip' title={globalSettings?.labels?.email?.[languageObj?.id]}
                                                                value={!isUndNullEmp({ data: building?.email, subMethod: currentMethod, })?.result ? building?.email : ''} />
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className={globalSettings?.icons?.envelope} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(emailError)}</div>
                                                    </div>

                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <textarea id={controls?.inputs?.address?.id}
                                                                className={controls?.inputs?.address?.className}
                                                                placeholder={globalSettings?.labels?.address?.[languageObj?.id]}
                                                                onChange={(e) => formDataSet({ property: 'address', value: e?.target?.value, subMethod: 'input - address', })}
                                                                onFocus={() => setAddressError('')}
                                                                tooltip='tooltip' title={globalSettings?.labels?.address?.[languageObj?.id]}
                                                                value={!isUndNullEmp({ data: building?.address, subMethod: currentMethod, })?.result ? building?.address : ''}>
                                                            </textarea>
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className='fas fa-map-marked-alt' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(addressError)}</div>
                                                    </div>
                                                </div>

                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            {/* <input className='form-control'
                                                            placeholder={globalSettings?.labels?.contract?.[languageObj?.id]}
                                                            onChange={(e) => formDataSet('contract', e.target.contract)}
                                                            onFocus={() => setContractError('')}
                                                            tooltip='tooltip' title={globalSettings?.labels?.contract?.[languageObj?.id]}
                                                            value={!isUndefined(building.contract) ? building.contract : ''} /> */}
                                                            <input id={controls?.inputs?.contract?.id}
                                                                className={controls?.inputs?.contract?.className}
                                                                placeholder={globalSettings?.labels?.contract?.[languageObj?.id]}
                                                                //onChange={(e) => formDataSet('contract', e.target.contract)}
                                                                onFocus={() => setContractError('')}
                                                                readOnly
                                                                tooltip='tooltip' title={globalSettings?.labels?.contract?.[languageObj?.id]}
                                                                value={!isUndNullEmp({ data: building?.contractId, subMethod: currentMethod, })?.result ? building?.contractId : ''} />
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className={globalSettings?.icons?.fileInvoice} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(contractError)}</div>
                                                    </div>
                                                </div>

                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        {/* <div className='input-group mb-3'>
                                                                <input className='form-control' 
                                                                    placeholder={globalSettings?.labels?.date?.[languageObj?.id]} 
                                                                    onChange={(e) => formDataSet('contractDate', e?.target?.value)} 
                                                                    //onFocus={() => setRifError('')} 
                                                                    tooltip='tooltip' title={globalSettings?.labels?.date?.[languageObj?.id]}
                                                                    value={!isUndefined(building.contractDate) && !isEmpty(building.contractDate) ? dateTimeFormatSetTwo(building.contractDate, 'd/m/y', 12) : dateTimeFormatSetTwo(new Date()?.toISOString(), 'd/m/y', 12)} />
                                                                <div className='input-group-append'>
                                                                    <div className='input-group-text'>
                                                                        <span className={globalSettings?.icons?.calendarAlt} />
                                                                    </div>
                                                                </div>
                                                            </div> */}
                                                        {/* <DatePicker /> */}
                                                        {/* <div className='input-group mb-3'>
                                                                    {!isUndefined(building) && !isUndefined(building.contractDate) ?
                                                                        <div className='input-group date' id={buildingContractDateId} data-target-input='nearest'>
                                                                            <input className='form-control datetimepicker-input'
                                                                                data-target={`#${buildingContractDateId}`}
                                                                                data-toggle='datetimepicker'
                                                                                //onFocus={() => setDateError('')}
                                                                                placeholder={globalSettings?.labels?.date?.[languageObj?.id]}
                                                                                tooltip='tooltip' title={globalSettings?.labels?.date?.[languageObj?.id]}
                                                                                type='text' />
                                                                            <div className='input-group-append' data-target={`#${buildingContractDateId}`} data-toggle='datetimepicker'>
                                                                                <div className='input-group-text'><i className='fa fa-calendar'></i></div>
                                                                            </div>
                                                                        </div>
                                                                        : <></>}
                                                                </div> */}
                                                        {/* <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(dateError)}</div> */}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <select id={controls?.selects?.coinBase?.id}
                                                                className={controls?.selects?.coinBase?.className}
                                                                value={!isUndNullEmp({ data: building?.coinBaseId, subMethod: currentMethod, })?.result ? building?.coinBaseId : ''}
                                                                onChange={(e) => formDataSet({ property: 'coinBaseId', value: e?.target?.value, subMethod: 'input - coinBase', })}
                                                                onFocus={() => setCoinBaseError('')}>
                                                                <option key='nothing' value=''>{globalSettings?.labels?.selectCoinBase?.[languageObj?.id]}</option>
                                                                {coins?.map((coin) => <option key={coin.id} value={coin.id}>{coin.description}</option>)};
                                                            </select>
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className='fas fa-coins' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(coinBaseError)}</div>
                                                    </div>
                                                </div>

                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <select id={controls?.selects?.coinOther?.id}
                                                                className={controls?.selects?.coinOther?.className}
                                                                value={!isUndNullEmp({ data: building?.coinOtherId, subMethod: currentMethod, })?.result ? building?.coinOtherId : ''}
                                                                onChange={(e) => formDataSet({ property: 'coinOtherId', value: e?.target?.value, subMethod: 'input - coinOther', })}
                                                                onFocus={() => setCoinOtherError('')}>
                                                                <option key='nothing' value=''>{globalSettings?.labels?.selectCoinOther?.[languageObj?.id]}</option>
                                                                {coins?.map((coin) => <option key={coin.id} value={coin.id}>{coin.description}</option>)};
                                                            </select>
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className='fas fa-comments-dollar' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(coinOtherError)}</div>
                                                    </div>

                                                </div>

                                                <div className='col-md-4'>
                                                    {/* <div className='form-group text-right'>
                                                            <button className='btn btn-outline-warning' tooltip='tooltip' title={globalSettings?.labels?.save?.[languageObj?.id]} type='submit'><i className={globalSettings?.icons?.save}></i></button>
                                                            <button className='btn btn-outline-info mx-1' tooltip='tooltip' title={globalSettings?.labels?.createContract} type='button' onClick={(e) => contractAsync(e)} disabled={!(!isEmpty(building.id) && userRole === globalSettings?.roles?.admin)} ><i className={globalSettings?.icons?.fileInvoice}></i></button>
                                                            <button className='btn btn-outline-success' tooltip='tooltip' title={globalSettings?.labels?.back?.[languageObj?.id]} type='reset' onClick={(e) => goBackAsync(e)}><i className={globalSettings?.icons?.arrowCircleLeft}></i></button>
                                                        </div> */}
                                                </div>
                                            </div>

                                            {/* </div> :
                                                <></>} */}

                                        </div> {/*card body*/}

                                        {/*card footer*/}
                                        {/* <div className='card-footer'>

                                    </div> */}

                                    </div>{/*card*/}

                                    {/*floors / parking stalls*/}
                                    <div className='card card-outline card-primary shadow-lg'>
                                        <LoadingSection alt='loadingSection'
                                            className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                            showText={true}
                                            text={globalSettings?.messages?.processing?.[languageObj?.id]}
                                            height={25}
                                            hidden={!showLoading?.floorsParkingStalls}
                                            width={25}
                                            languageId={languageObj?.id}
                                            subMethod={currentMethod} />

                                        {/*card header*/}
                                        <div className='card-header'>
                                            <h6 className='card-title'>
                                                <img alt={globalSettings?.labels?.floors?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.handRailsLogo}></img> - {`${globalSettings?.labels?.floors?.[languageObj?.id]} / ${globalSettings?.labels?.parking}`}
                                            </h6>
                                            <div className='card-tools'>
                                                <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                    <i className={globalSettings?.icons?.minus}></i>
                                                </button>
                                            </div>
                                        </div>

                                        {/*card body*/}
                                        <div className='card-body'>
                                            {/* {!isUndefined(building) && !isNull(building) && !isEmpty(building) ?
                                                <div> */}

                                            {/*top level*/}
                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <div className={controls?.checkBox?.topLevel?.className}>
                                                                <input type='checkbox'
                                                                    disabled={floorsIsDisabled}
                                                                    id={controls?.checkBox?.topLevel?.id}
                                                                    checked={building?.topLevel || false}
                                                                    onChange={(e) => apartmentsTopLevelSet({ e: e, subMethod: 'chk - topLevel', })} />
                                                                <label htmlFor={controls?.checkBox?.topLevel?.id}
                                                                    style={{ fontWeight: 'normal' }} >
                                                                    {`${globalSettings?.labels?.topLevel?.[languageObj?.id]}?`}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <input className={controls?.inputs?.apartmentsPerTopLevel?.className}
                                                                //disabled={!building.topLevel}
                                                                disabled={!building.topLevel || floorsIsDisabled}
                                                                id={controls?.inputs?.apartmentsPerTopLevel?.id}
                                                                onChange={(e) => formDataSet({ property: 'apartmentsPerTopLevel', value: parseInt(e?.target?.value), subMethod: 'input - apartmentsPerTopLevel', })}
                                                                onFocus={() => setApartmentsPerTopLevelError('')}
                                                                placeholder={globalSettings?.labels?.apartmentsPerTopLevel?.[languageObj?.id]}
                                                                tooltip='tooltip' title={globalSettings?.labels?.apartmentsPerTopLevel?.[languageObj?.id]}
                                                                type='number'
                                                                value={!isUndNullEmp({ data: building?.apartmentsPerTopLevel, subMethod: currentMethod, })?.result && building?.apartmentsPerTopLevel > 0 ?
                                                                    building?.apartmentsPerTopLevel : ''} />
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className='fas fa-house-user' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(apartmentsPerTopLevelError)}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/*floors*/}
                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <input id={controls?.inputs?.floors?.id}
                                                                className={controls?.inputs?.floors?.className}
                                                                disabled={floorsIsDisabled}
                                                                placeholder={globalSettings?.labels?.floors?.[languageObj?.id]}
                                                                onChange={(e) => formDataSet({ property: 'floors', value: parseInt(e?.target?.value), subMethod: 'input - floors', })}
                                                                onFocus={() => setApartmentsPerFloorsError('')}
                                                                tooltip='tooltip'
                                                                title={globalSettings?.labels?.floors?.[languageObj?.id]}
                                                                type='number'
                                                                value={!isUndNullEmp({ data: building?.floors, subMethod: currentMethod, })?.result && building?.floors > 0 ? building?.floors : ''} />
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className={globalSettings?.icons?.layerGroup} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <input id={controls?.inputs?.apartmentsPerFloor?.id}
                                                                className={controls?.inputs?.apartmentsPerFloor?.className}
                                                                //disabled={!(building.floors > 0)}
                                                                disabled={!(building.floors > 0) || floorsIsDisabled}
                                                                placeholder={globalSettings?.labels?.apartmentsPerFloor?.[languageObj?.id]}
                                                                onChange={(e) => formDataSet({ property: 'apartmentsPerFloor', value: parseInt(e?.target?.value), subMethod: 'input - apartmentsPerFloor', })}
                                                                onFocus={() => setApartmentsPerFloorsError('')}
                                                                tooltip='tooltip' title={globalSettings?.labels?.apartmentsPerFloor?.[languageObj?.id]}
                                                                type='number'
                                                                value={
                                                                    !isUndNullEmp({ data: building?.floors, subMethod: currentMethod, })?.result && building?.floors > 0 ?
                                                                        (!isUndNullEmp({ data: building?.apartmentsPerFloor, subMethod: currentMethod, })?.result && building?.apartmentsPerFloor > 0 ?
                                                                            building.apartmentsPerFloor : '') :
                                                                        ''} />
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className='fas fa-house-user' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(apartmentsPerFloorsError)}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/*low level*/}
                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <div className={controls?.checkBox?.lowLevel?.className}>
                                                                <input type='checkbox'
                                                                    disabled={floorsIsDisabled}
                                                                    id={controls?.checkBox?.lowLevel?.id}
                                                                    checked={building?.lowLevel || false}
                                                                    onChange={(e) => apartmentsLowLevelSet({ e: e, subMethod: 'chk - apartmentsLowLevel', })} />
                                                                <label htmlFor={controls?.checkBox?.lowLevel?.id}
                                                                    style={{ fontWeight: 'normal' }} >
                                                                    {`${globalSettings?.labels?.lowLevel?.[languageObj?.id]}?`}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <input id={controls?.inputs?.apartmentsPerLowLevel?.id}
                                                                className={controls?.inputs?.apartmentsPerLowLevel?.className}
                                                                //disabled={!building.lowLevel}
                                                                disabled={!building?.lowLevel || floorsIsDisabled}
                                                                onChange={(e) => formDataSet({ property: 'apartmentsPerLowLevel', value: parseInt(e?.target?.value), subMethod: 'input - apartmentsPerLowLevel', })}
                                                                onFocus={() => setApartmentsPerLowLevelError('')}
                                                                placeholder={globalSettings?.labels?.apartmentsPerLowLevel?.[languageObj?.id]}
                                                                tooltip='tooltip' title={globalSettings?.labels?.apartmentsPerLowLevel?.[languageObj?.id]}
                                                                type='number'
                                                                value={!isUndNullEmp({ data: building?.apartmentsPerLowLevel, subMethod: currentMethod, })?.result && building?.apartmentsPerLowLevel > 0 ?
                                                                    building?.apartmentsPerLowLevel : ''} />
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className='fas fa-house-user' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(apartmentsPerLowLevelError)}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/*commands*/}
                                            <div className='row'>
                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <input id={controls?.inputs?.parkingStalls?.id}
                                                                className={controls?.inputs?.parkingStalls?.className}
                                                                onChange={(e) => formDataSet({ property: 'parkingStalls', value: parseInt(e?.target?.value), subMethod: 'input - parkingStalls', })}
                                                                placeholder={globalSettings?.labels?.parkingStalls?.[languageObj?.id]}
                                                                tooltip='tooltip' title={globalSettings?.labels?.parkingStalls?.[languageObj?.id]}
                                                                type='number'
                                                                value={!isUndNullEmp({ data: building?.parkingStalls, subMethod: currentMethod, })?.result && building?.parkingStalls > 0 ?
                                                                    building?.parkingStalls : ''} />
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className={globalSettings?.icons?.car} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <input className='form-control' type='text' readOnly value={`${globalSettings?.labels?.totalApartments?.[languageObj?.id]}: ${totalApartments}`} />
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className={globalSettings?.icons?.fasFa?.sortAmountUpAlt} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-md-4'>
                                                    <div className='form-group text-right'>
                                                        <button id={controls?.buttons?.save?.id}
                                                            className={controls?.buttons?.save?.className}
                                                            tooltip='tooltip'
                                                            title={globalSettings?.labels?.save?.[languageObj?.id]}
                                                            type='submit'>
                                                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                                                        </button>
                                                        <button id={controls?.buttons?.contract?.id}
                                                            className={controls?.buttons?.contract?.className}
                                                            //disabled={!(!isEmpty(building.id) && userRole === globalSettings?.roles?.admin)} 
                                                            disabled={!(!isUndNullEmp({ data: building, subMethod: 'btn - contract', })?.result)}
                                                            tooltip='tooltip'
                                                            title={globalSettings?.labels?.contract?.[languageObj?.id]}
                                                            type='button'
                                                            onClick={(e) => contractAsync(e)}>
                                                            <i id={controls?.icons?.contract?.id} className={controls?.icons?.contract?.className} /> <span id={controls?.spinners?.contract?.id} className='' aria-hidden='true'></span>
                                                        </button>
                                                        <button id={controls?.buttons?.back?.id}
                                                            className={controls?.buttons?.back?.className}
                                                            tooltip='tooltip'
                                                            title={globalSettings?.labels?.back?.[languageObj?.id]}
                                                            type='reset'
                                                            onClick={(e) => goBackAsync({ e: e, subMethod: 'cmd - back', })}>
                                                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* </div> :
                                                <></>} */}

                                        </div> {/*card body*/}

                                        {/*card footer*/}
                                        {/* <div className='card-footer'>

                                    </div> */}

                                    </div>{/*card*/}
                                </form>

                                {/* {!showLoading ? */}
                                <div>
                                    {/* {showData ?
                                            <div> */}
                                    {/*elevators*/}
                                    <div className='card card-outline card-primary shadow-lg'>
                                        <LoadingSection alt='loadingSection'
                                            className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                            showText={true}
                                            text={globalSettings?.messages?.processing?.[languageObj?.id]}
                                            height={25}
                                            hidden={!showLoading?.elevators}
                                            width={25}
                                            languageId={languageObj?.id}
                                            subMethod={currentMethod} />

                                        {/*card header*/}
                                        <div className='card-header'>
                                            <h6 className='card-title'>
                                                <img alt={globalSettings?.labels?.elevators?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.elevatorsLogo}></img> - {globalSettings?.labels?.elevators?.[languageObj?.id]}
                                            </h6>
                                            <div className='card-tools'>
                                                <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                    <i className={globalSettings?.icons?.minus}></i>
                                                </button>
                                            </div>
                                        </div>

                                        {/*card body*/}
                                        <div className='card-body'>
                                            {/* {!isUndefined(building) && !isNull(building) && !isEmpty(building) ?
                                                <div> */}
                                            {/*elevators*/}
                                            <div className='row'>
                                                <div className='col-md-12'>
                                                    <button id={controls?.dataTables?.elevators?.buttons?.add?.id}
                                                        className={controls?.dataTables?.elevators?.buttons?.add?.className}
                                                        tooltip='tooltip'
                                                        title={globalSettings?.labels?.create?.[languageObj?.id]}
                                                        onClick={(e) => elevatorAddGetAsync({ e: e, subMethod: e?.currentTarget?.id, })}>
                                                        <i id={controls?.dataTables?.elevators?.icons?.add?.id} className={controls?.dataTables?.elevators?.icons?.add?.className} /> <span id={controls?.dataTables?.elevators?.spinners?.add?.id} className='' aria-hidden='true'></span>
                                                    </button>
                                                    <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                        <table id={dtElevatorsId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* </div> :
                                                            <></>} */}

                                        </div> {/*card body*/}

                                        {/*card footer*/}
                                        {/* <div className='card-footer'></div> */}

                                    </div>{/*card*/}

                                    {/*inventory*/}
                                    <div className='card card-outline card-primary shadow-lg'>
                                        <LoadingSection alt='loadingSection'
                                            className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                            showText={true}
                                            text={globalSettings?.messages?.processing?.[languageObj?.id]}
                                            height={25}
                                            hidden={!showLoading?.inventory}
                                            width={25}
                                            languageId={languageObj?.id}
                                            subMethod={currentMethod} />

                                        {/*card header*/}
                                        <div className='card-header'>
                                            <h6 className='card-title'>
                                                <img alt={globalSettings?.labels?.inventory?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.inventoriesLogo}></img> - {globalSettings?.labels?.inventory?.[languageObj?.id]}
                                            </h6>
                                            <div className='card-tools'>
                                                <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                    <i className={globalSettings?.icons?.minus}></i>
                                                </button>
                                            </div>
                                        </div>

                                        {/*card body*/}
                                        <div className='card-body'>

                                            {/* {!isUndefined(building) && !isNull(building) && !isEmpty(building) ?
                                                            <div> */}

                                            {/*inventory*/}
                                            <div className='row'>
                                                <div className='col-md-12'>
                                                    <button id={controls?.dataTables?.inventories?.buttons?.add?.id}
                                                        className={controls?.dataTables?.inventories?.buttons?.add?.className}
                                                        tooltip='tooltip'
                                                        title={globalSettings?.labels?.create?.[languageObj?.id]}
                                                        onClick={() => inventoryAddGetAsync({ subMethod: 'dataTableInventories - btnAdd', })}>
                                                        <i id={controls?.dataTables?.inventories?.icons?.add?.id} className={controls?.dataTables?.inventories?.icons?.add?.className} /> <span id={controls?.dataTables?.inventories?.spinners?.add?.id} className='' aria-hidden='true'></span>
                                                    </button>
                                                    <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                        <table id={dtInventoriesId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* </div> :
                                                            <></>} */}

                                        </div> {/*card body*/}

                                        {/*card footer*/}
                                        {/* <div className='card-footer'></div> */}

                                    </div>{/*card*/}

                                    {/*Common areas*/}
                                    <div className='card card-outline card-primary shadow-lg'>
                                        <LoadingSection alt='loadingSection'
                                            className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                            showText={true}
                                            text={globalSettings?.messages?.processing?.[languageObj?.id]}
                                            height={25}
                                            hidden={!showLoading?.commonArea}
                                            width={25}
                                            languageId={languageObj?.id}
                                            subMethod={currentMethod} />

                                        {/*card header*/}
                                        <div className='card-header'>
                                            <h6 className='card-title'>
                                                <img alt={globalSettings?.labels?.commonAreas?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.partyFlags}></img> - {globalSettings?.labels?.commonAreas?.[languageObj?.id]}
                                            </h6>
                                            <div className='card-tools'>
                                                <button type='button'
                                                    className='btn btn-tool'
                                                    data-card-widget='collapse'>
                                                    <i className={globalSettings?.icons?.minus}></i>
                                                </button>
                                            </div>
                                        </div>

                                        {/*card body*/}
                                        <div className='card-body'>

                                            {/* {!isUndefined(building) && !isNull(building) && !isEmpty(building) ?
                                                            <div> */}

                                            {/*Common area*/}
                                            <div className='row'>
                                                <div className='col-md-12'>
                                                    <button tooltip='tooltip'
                                                        title={globalSettings?.labels?.create?.[languageObj?.id]}
                                                        className='btn btn-outline-success float-right btn-sm'
                                                        onClick={() => commonAreaAddEditDeleteAsync('', '', 0, 0)}>
                                                        <i id={controls?.dataTables?.commonAreas?.icons?.add?.id} className={controls?.dataTables?.commonAreas?.icons?.add?.className} /> <span id={controls?.dataTables?.commonAreas?.spinners?.add?.id} className='' aria-hidden='true'></span>
                                                    </button>
                                                    <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                        <table id={dtCommonAreasId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* </div> :
                                                            <></>} */}

                                        </div> {/*card body*/}

                                        {/*card footer*/}
                                        {/* <div className='card-footer'></div> */}

                                    </div>{/*card*/}

                                    {/*settings (users)*/}
                                    <div className='card card-outline card-primary shadow-lg'>
                                        <LoadingSection alt='loadingSection'
                                            className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                            showText={true}
                                            text={globalSettings?.messages?.processing?.[languageObj?.id]}
                                            height={25}
                                            hidden={!showLoading?.settings}
                                            width={25}
                                            languageId={languageObj?.id}
                                            subMethod={currentMethod} />

                                        {/*card header*/}
                                        <div className='card-header'>
                                            <h6 className='card-title'>
                                                <img alt={globalSettings?.labels?.setting?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.settings}></img> - {globalSettings?.labels?.setting?.[languageObj?.id]}
                                            </h6>
                                            <div className='card-tools'>
                                                <button type='button'
                                                    className='btn btn-tool'
                                                    data-card-widget='collapse'>
                                                    <i className={globalSettings?.icons?.minus}></i>
                                                </button>
                                            </div>
                                        </div>

                                        {/*card body*/}
                                        <div className='card-body'>
                                            <form onSubmit={(e) => buildingSettingsEditAsync({ e: e, subMethod: 'form - settings' })}>
                                                <div className='card card-primary card-outline card-outline-tabs'>
                                                    <div className='card-header p-0 border-bottom-0'>
                                                        <ul className='nav nav-tabs' id='custom-tabs-four-tab' role='tablist'>
                                                            <li className='nav-item'>
                                                                <a className='nav-link active' id={tabs?.ids?.accountsReceivable} data-toggle='pill' href={`#${tabs?.panes?.ids?.accountsReceivable}`} role='tab' aria-controls={tabs?.panes?.ids?.accountsReceivable} aria-selected='true'>{globalSettings?.labels?.accountsReceivable?.[languageObj?.id]}</a>
                                                            </li>
                                                            <li className='nav-item'>
                                                                <a className='nav-link' id={tabs?.ids?.accountsPayable} data-toggle='pill' href={`#${tabs?.panes?.ids?.accountsPayable}`} role='tab' aria-controls={tabs?.panes?.ids?.accountsPayable} aria-selected='false'>{globalSettings?.labels?.accountsPayable?.[languageObj?.id]}</a>
                                                            </li>
                                                            <li className='nav-item'>
                                                                <a className='nav-link' id={tabs?.ids?.collectionCashes} data-toggle='pill' href={`#${tabs?.panes?.ids?.collectionCashes}`} role='tab' aria-controls={tabs?.panes?.ids?.collectionCashes} aria-selected='false'>{globalSettings?.labels?.collectionCashes?.[languageObj?.id]}</a>
                                                            </li>
                                                            <li className='nav-item'>
                                                                <a className='nav-link' id={tabs?.ids?.bankAccounts} data-toggle='pill' href={`#${tabs?.panes?.ids?.bankAccounts}`} role='tab' aria-controls={tabs?.panes?.ids?.bankAccounts} aria-selected='false'>{globalSettings?.labels?.bankAccounts?.[languageObj?.id]}</a>
                                                            </li>
                                                            <li className='nav-item'>
                                                                <a className='nav-link' id={tabs?.ids?.users} data-toggle='pill' href={`#${tabs?.panes?.ids?.users}`} role='tab' aria-controls={tabs?.panes?.ids?.users} aria-selected='false'>{globalSettings?.labels?.users?.[languageObj?.id]}</a>
                                                            </li>
                                                        </ul>
                                                    </div>

                                                    <div className='card-body'>
                                                        <div className='tab-content' id='custom-tabs-four-tabContent'>
                                                            <div className='tab-pane fade show active' id={tabs?.panes?.ids?.accountsReceivable} role={tabs?.panes?.role} aria-labelledby={tabs?.ids?.accountsReceivable}>
                                                                <div className='row'>

                                                                    <div className='col-md-4'>
                                                                        <div className='form-group'>
                                                                            <div className='input-group mb-3'>
                                                                                <div className='icheck-primary d-inline'>
                                                                                    <input type='checkbox'
                                                                                        disabled={isEditDelete}
                                                                                        id={aliquotPercentageId}
                                                                                        checked={building?.settings?.accountsReceivable?.aliquotPercentage || false}
                                                                                        onChange={(e) => buildingSettingsDataSet({
                                                                                            e: e,
                                                                                            processType: processName?.accountsReceivableAliquotPercentage,
                                                                                            subMethod: 'checkBox - aliquotPercentage',
                                                                                        })} />
                                                                                    <label htmlFor={aliquotPercentageId}
                                                                                        style={{ fontWeight: 'normal' }}>
                                                                                        {`${globalSettings?.labels?.distributeCostsByPercentage?.[languageObj?.id]}?`}
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className='col-md-4'></div>
                                                                    <div className='col-md-4'></div>

                                                                </div>

                                                            </div>
                                                            <div className={tabs?.className} id={tabs?.panes?.ids?.accountsPayable} role={tabs?.panes?.role} aria-labelledby={tabs?.ids?.accountsPayable}>
                                                                tab: {globalSettings?.labels?.accountsPayable?.[languageObj?.id]}
                                                            </div>
                                                            <div className={tabs?.className} id={tabs?.panes?.ids?.collectionCashes} role={tabs?.panes?.role} aria-labelledby={tabs?.ids?.collectionCashes}>
                                                                tab: {globalSettings?.labels?.collectionCashes?.[languageObj?.id]}
                                                            </div>
                                                            <div className={tabs?.className} id={tabs?.panes?.ids?.bankAccounts} role={tabs?.panes?.role} aria-labelledby={tabs?.ids?.bankAccounts}>
                                                                tab: {globalSettings?.labels?.bankAccounts?.[languageObj?.id]}
                                                            </div>
                                                            <div className={tabs?.className} id={tabs?.panes?.ids?.users} role={tabs?.panes?.role} aria-labelledby={tabs?.ids?.users}>
                                                                <div className='row'>

                                                                    <div className='col-md-4'>
                                                                        <div className='form-group'>
                                                                            <div className='input-group mb-3'>
                                                                                <select value={!isUndNullEmp({ data: building?.settings?.users?.maxLockoutAttemps, subMethod: currentMethod, })?.result ?
                                                                                    `${parseInt(building?.settings?.users?.maxLockoutAttemps)}` : `0`}
                                                                                    className='form-select'
                                                                                    onChange={(e) => buildingSettingsDataSet({
                                                                                        e: e,
                                                                                        processType: processName?.usersMaxLockoutAttemps,
                                                                                        subMethod: 'select - maxLockoutAttemps',
                                                                                    })}
                                                                                    onFocus={(e) => e.preventDefault()}
                                                                                    placeholder={globalSettings?.labels?.maxAttemptsToLock?.[languageObj?.id]}
                                                                                    title={globalSettings?.labels?.maxAttemptsToLock?.[languageObj?.id]}>
                                                                                    {/* <option key='nothing' value=''>{globalSettings?.labels?.selectCoinBase}</option> */}
                                                                                    {/* {maxLockoutAttemps.map((attemp) => <option key={attemp.id} value={attemp.id}>{attemp.id}</option>)}; */}
                                                                                    {maxLockoutAttemps.map((attemp) => <option key={attemp.id} value={attemp.id}>{attemp.description}</option>)};
                                                                                </select>
                                                                                <div className='input-group-append'>
                                                                                    <div className='input-group-text'>
                                                                                        <span className={globalSettings?.icons?.userLock} />
                                                                                    </div>
                                                                                </div>
                                                                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser('')}</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className='col-md-4'></div>
                                                                    <div className='col-md-4'></div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='form-group text-right'>
                                                    <button className='btn btn-outline-warning mx-1'
                                                        disabled={isEditDelete}
                                                        tooltip='tooltip'
                                                        title={globalSettings?.labels?.save?.[languageObj?.id]}
                                                        type='submit'>
                                                        <i className={globalSettings?.icons?.save}></i>
                                                    </button>

                                                </div>
                                            </form>
                                        </div> {/*card body*/}

                                        {/*card footer*/}
                                        {/* <div className='card-footer'></div> */}

                                    </div>{/*card*/}
                                    {/* </div>
                                            :
                                            <div></div>
                                        } */}
                                </div>
                                {/* :
                                    <div>
                                        <CssfxLoading type={globalSettings?.react?.CssfxLoading?.circularProgress}
                                            width={40}
                                            height={40}
                                            color={globalSettings?.colors?.infoColorExp}
                                            msgText={globalSettings?.messages?.processing?.[languageObj?.id]}
                                            msgOrientation='text-center'
                                            msgTextMuted={true} />
                                    </div>
                                } */}
                            </div>{/*col*/}
                        </div>{/*row*/}

                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content */}

            </div>

            {showModalElevator ?
                <ElevatorAddEditDetails $={$}
                    auth={auth}
                    showModal={showModalElevator}
                    setShowModal={setShowModalElevator}
                    building={building}
                    buildingTwo={buildingTwo}
                    elevator={elevator}
                    setElevator={setElevator}
                    elevatorGetType={elevatorGetType}
                    processValues={processValues}
                    languageObj={languageObj} />
                :
                <></>
            }

            {showModalInventory ?
                <InventoryAddEditDetails $={$}
                    showModal={showModalInventory}
                    setShowModal={setShowModalInventory}
                    building={building}
                    buildingTwo={buildingTwo}
                    inventory={inventory}
                    setInventory={setInventory}
                    processValues={processValues}
                    languageObj={languageObj} />
                :
                <></>
            }

            {commonAreaShowModal ?
                <CommonAreaAddEditDetails $={$}
                    processValues={processValues}
                    building={building}
                    buildingTwo={buildingTwo}
                    commonArea={commonArea}
                    setCommonArea={setCommonArea}
                    languageObj={languageObj} />
                :
                <></>
            }

            {contractShowModal ?
                <BuildingContracts $={$}
                    auth={auth}
                    dtId={contractsDtId}
                    rowIndex={0}
                    showModal={contractShowModal}
                    setShowModal={setContractShowModal}
                    type={(userRole === globalSettings?.roles?.master || userRole === globalSettings?.roles?.admin ? 0 : 2)}
                    building={building}
                    contracts={contracts}
                    setContracts={setContracts}
                    contractsDt={contractsDt}
                    setContractsDt={setContractsDt}
                    languageObj={languageObj} />
                :
                <></>
            }

        </div>
    )
}